
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("6KIlt", function(module, exports) {

$parcel$export(module.exports, "NavigationProfileNavItemWrapperNudge", () => $b91081d3ff9b7df0$export$e037802c896cf0c);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $6xOhZ = parcelRequire("6xOhZ");

var $7dRgX = parcelRequire("7dRgX");
var $5cLMB = parcelRequire("5cLMB");

var $iyAyt = parcelRequire("iyAyt");

var $8AAak = parcelRequire("8AAak");

var $b8MfW = parcelRequire("b8MfW");
const $b91081d3ff9b7df0$export$e037802c896cf0c = ({ children: children, nudgeId: nudgeId })=>{
    const [nudgeStep, { setNudgeStep: setNudgeStep }] = (0, $5cLMB.useNudgeStep)();
    const [hasNudgeActive, { setHasNudgeActive: setHasNudgeActive }] = (0, $5cLMB.useHasNudgeActive)();
    const hideNudge = ()=>{
        setNudgeStep('');
        setHasNudgeActive(false);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iyAyt.InstrumentedNudgeSpotlightCard), {
        nudgeId: nudgeId,
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6xOhZ.InterpolatedFormattedMessage), {
            messageDescriptor: (0, $b8MfW.default).content,
            messageMappings: {
                tag: (0, $8AAak.BoldWrapper)
            }
        })),
        width: (0, $7dRgX.DEFAULT_NUDGE_WIDTH),
        hidden: nudgeStep !== nudgeId || hasNudgeActive === false,
        setHidden: hideNudge,
        onOutsideClick: hideNudge
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b91081d3ff9b7df0$var$ChildrenWrapper, null, children));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b91081d3ff9b7df0$var$ChildrenWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_14mj1ssb _rfx31ssb _z0ai14no _1mp414no _19do1ssb _qnec1ssb _clh3zr6s _7dwzzr6s",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6xOhZ", function(module, exports) {

$parcel$export(module.exports, "InterpolatedFormattedMessage", () => $1da2023460d08bf9$export$3379b4801cfda3a);

var $eUqFw = parcelRequire("eUqFw");

var $3x4sL = parcelRequire("3x4sL");

var $5JgJ2 = parcelRequire("5JgJ2");

var $63FwL = parcelRequire("63FwL");
const $1da2023460d08bf9$export$3379b4801cfda3a = ({ messageDescriptor: messageDescriptor, messageMappings: messageMappings, messageContexts: messageContexts })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const tags = Object.keys(messageMappings);
    const tagFormatMessageValues = (0, $63FwL.getTagFormatMessageValues)(tags);
    const formatMessageValues = {
        ...tagFormatMessageValues,
        ...messageContexts
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3x4sL.FormattedI18nMessage), {
        componentsMapping: messageMappings,
        message: formatMessage(messageDescriptor, formatMessageValues)
    });
};

});
parcelRegister("3x4sL", function(module, exports) {

$parcel$export(module.exports, "FormattedI18nMessage", () => $88ddecd12f0773cd$export$200d7bd7633253ce);

var $eUqFw = parcelRequire("eUqFw");

var $dO2kc = parcelRequire("dO2kc");

var $6nVYw = parcelRequire("6nVYw");
const $88ddecd12f0773cd$export$200d7bd7633253ce = (props)=>{
    const { message: message, packageName: packageName, componentsMapping: componentsMapping } = props;
    const messageParts = (0, $eUqFw.useMemo)(()=>{
        const { tags: tags, openTags: openTags, closeTags: closeTags } = (0, $6nVYw.getTags)(componentsMapping);
        try {
            const parts = [];
            let token = '';
            let TagComponent;
            let closeTagLookup;
            for(let i = 0; i < message.length; i += 1){
                const letter = message[i];
                token += letter;
                if ((0, $6nVYw.isCloseTagDelimiter)(letter)) {
                    const firstTagFound = (0, $6nVYw.findTag)(token, {
                        tags: openTags
                    });
                    if (firstTagFound !== null && firstTagFound !== undefined) {
                        // if we have a tag already means it is a malformed message since it is 2 subsequent open tags
                        if (TagComponent) throw new (0, $dO2kc.MalformedMessageError)();
                        const text = token.replace(firstTagFound, '');
                        parts.push(text);
                        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
                        const tagInfo = tags[firstTagFound];
                        TagComponent = tagInfo.component;
                        closeTagLookup = tagInfo.close;
                        token = '';
                    }
                }
                if (closeTagLookup !== null && closeTagLookup !== undefined && (0, $6nVYw.isCloseTagDelimiter)(letter) && (0, $6nVYw.isAnyTag)(token, {
                    tags: [
                        closeTagLookup
                    ]
                })) {
                    // this mean that we do not have an open tag for this closing tag
                    if (!TagComponent) throw new (0, $dO2kc.MalformedMessageError)();
                    const text = token.replace(closeTagLookup, '');
                    parts.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TagComponent, null, text));
                    TagComponent = undefined;
                    token = '';
                    closeTagLookup = undefined;
                }
                if ((0, $6nVYw.isCloseTagDelimiter)(letter) && (0, $6nVYw.isAnyTag)(token, {
                    tags: closeTags
                })) {
                    // if we do not have an open tag mean we are closing a tag that is not open
                    if (!TagComponent) throw new (0, $dO2kc.MalformedMessageError)();
                }
            }
            // if we reached the end and we have an open tag, mean this message is malformed
            if (TagComponent || closeTagLookup) throw new (0, $dO2kc.MalformedMessageError)();
            // flush anything we keep in the current token
            if (token.length > 0) parts.push(token);
            return parts;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            if (e instanceof (0, $dO2kc.MalformedMessageError)) {
                (0, $dO2kc.logMalformedMessageError)({
                    message: message,
                    packageName: packageName
                });
                return [
                    (0, $dO2kc.getMalformedMessage)({
                        message: message,
                        closeTags: closeTags,
                        openTags: openTags
                    })
                ];
            }
            throw e;
        }
    }, [
        message,
        packageName,
        componentsMapping
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, messageParts.map((item, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), {
            key: index
        }, item)));
};

});
parcelRegister("dO2kc", function(module, exports) {

$parcel$export(module.exports, "getMalformedMessage", () => $1a42e2705665fc85$export$f085cf20ec1f69ab);
$parcel$export(module.exports, "logMalformedMessageError", () => $1a42e2705665fc85$export$954c3e6aad1c9429);
$parcel$export(module.exports, "MalformedMessageError", () => $1a42e2705665fc85$export$40d900e818b9630e);

var $gUUjF = parcelRequire("gUUjF");

var $guiFP = parcelRequire("guiFP");

const $1a42e2705665fc85$export$f085cf20ec1f69ab = ({ message: message, openTags: openTags, closeTags: closeTags })=>[
        ...openTags,
        ...closeTags
    ].reduce((acc, tag)=>acc.replace(new RegExp(tag, 'g'), ''), message);
const $1a42e2705665fc85$export$954c3e6aad1c9429 = ({ message: message, packageName: packageName })=>{
    if (packageName !== null && packageName !== undefined) {
        const errorMessage = `Malformed message: ${message}`;
        // Send error log to analytics pipeline (i.e. SFX) and Sentry
        (0, $guiFP.default)({
            meta: {
                packageName: packageName,
                id: (0, $376af31d5cd90f0d$export$f3390a0e172fee41)
            },
            attributes: {
                message: errorMessage
            }
        });
        // Send error log to Splunk
        const location = `${packageName}.${(0, $376af31d5cd90f0d$export$f3390a0e172fee41)}`;
        (0, $gUUjF.default).unsafeErrorWithCustomerData(location, errorMessage);
    }
};
class $1a42e2705665fc85$export$40d900e818b9630e extends Error {
    constructor(){
        super('Malformed i18n message');
    }
}

});
const $376af31d5cd90f0d$export$f3390a0e172fee41 = 'formattedI18NMessage';


parcelRegister("6nVYw", function(module, exports) {

$parcel$export(module.exports, "getTags", () => $ec16d76793463e9e$export$af63d7414243dad3);
$parcel$export(module.exports, "isAnyTag", () => $ec16d76793463e9e$export$38ffa64fc639355f);
$parcel$export(module.exports, "findTag", () => $ec16d76793463e9e$export$dfca0f74034f8657);
$parcel$export(module.exports, "isCloseTagDelimiter", () => $ec16d76793463e9e$export$d5170904651e91b1);

const $ec16d76793463e9e$export$af63d7414243dad3 = (componentsMapping)=>Object.entries(componentsMapping).reduce(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (acc, [key, value])=>{
        const open = `{${key}Start}`;
        const close = `{${key}End}`;
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
        acc.tags[open] = {
            close: close,
            component: value
        };
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
        acc.openTags.push(open);
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
        acc.closeTags.push(close);
        return acc;
    }, {
        tags: {},
        openTags: [],
        closeTags: []
    });
const $ec16d76793463e9e$export$38ffa64fc639355f = (text, { tags: tags })=>tags.some((tag)=>text.includes(tag));
const $ec16d76793463e9e$export$dfca0f74034f8657 = (text, { tags: tags })=>tags.find((tag)=>text.includes(tag));
const $ec16d76793463e9e$export$d5170904651e91b1 = (letter)=>letter === (0, $a86f32165c278403$export$a10c567c3288a6b4);

});
const $a86f32165c278403$export$a10c567c3288a6b4 = '}';



parcelRegister("63FwL", function(module, exports) {

$parcel$export(module.exports, "getTagFormatMessageValues", () => $d2fcb3180aa81983$export$884bf49a6231045);
const $d2fcb3180aa81983$export$884bf49a6231045 = (tags)=>{
    const tagSuffixes = [
        'Start',
        'End'
    ];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return tags.reduce((accumulator, tag)=>{
        tagSuffixes.forEach((suffix)=>{
            accumulator[`${tag}${suffix}`] = `{${tag}${suffix}}`;
        });
        return accumulator;
    }, {});
};

});


parcelRegister("5cLMB", function(module, exports) {

$parcel$export(module.exports, "JswOnboardingSubscriber", () => $502e2dc73b97f226$export$1cbc60d8dd921852);
$parcel$export(module.exports, "useJswOnboarding", () => $502e2dc73b97f226$export$7d91c0af4772787a);
$parcel$export(module.exports, "useOpenTask", () => $502e2dc73b97f226$export$594f006fa6a1b2e5);
$parcel$export(module.exports, "useNudgeStep", () => $502e2dc73b97f226$export$c5e63e44ad178ae8);
$parcel$export(module.exports, "useQuickstartActions", () => $502e2dc73b97f226$export$2c3cd14fff9d6e43);
$parcel$export(module.exports, "useShouldShowNudge", () => $502e2dc73b97f226$export$b0db7e46e369e1d9);
$parcel$export(module.exports, "useShouldShowOpenMenuItem", () => $502e2dc73b97f226$export$d994ff8c0341aba1);
$parcel$export(module.exports, "useInviteToProject", () => $502e2dc73b97f226$export$71de79653346a1ea);
$parcel$export(module.exports, "useShowVideoCards", () => $502e2dc73b97f226$export$61185a9266f1f57a);
$parcel$export(module.exports, "useProjectState", () => $502e2dc73b97f226$export$ef4747ba36826d6a);
$parcel$export(module.exports, "useQuickstartUiStatus", () => $502e2dc73b97f226$export$522993b46d9f8266);
$parcel$export(module.exports, "useIsLoaded", () => $502e2dc73b97f226$export$aa4ba29241532382);
$parcel$export(module.exports, "useIsFocusedOn", () => $502e2dc73b97f226$export$ed5c755b733bf2b1);
$parcel$export(module.exports, "useIsDismissed", () => $502e2dc73b97f226$export$35fe0366802512dd);
$parcel$export(module.exports, "useCompletedTaskList", () => $502e2dc73b97f226$export$a41ee0d3b6938099);
$parcel$export(module.exports, "useAllTasksCompleted", () => $502e2dc73b97f226$export$4ae7b465b076be9);
$parcel$export(module.exports, "useMountedNudges", () => $502e2dc73b97f226$export$bf6e646c0476acad);
$parcel$export(module.exports, "useHasEverSeen", () => $502e2dc73b97f226$export$6b706bff94798d11);
$parcel$export(module.exports, "useRoadmapState", () => $502e2dc73b97f226$export$c98db656edc5b3e1);
$parcel$export(module.exports, "useShouldShowScrumOnboardingExperience", () => $502e2dc73b97f226$export$a823278ac9d1112b);
$parcel$export(module.exports, "useShouldShowOnboardingKanbanTour", () => $502e2dc73b97f226$export$cb9e0e8fe4df8490);
$parcel$export(module.exports, "useHasNudgeActive", () => $502e2dc73b97f226$export$521909e3dc7ab811);
$parcel$export(module.exports, "useSelectedProjectTemplateKeyFromOnboarding", () => $502e2dc73b97f226$export$f4a2be940259bf95);
$parcel$export(module.exports, "usePersonaExperience", () => $502e2dc73b97f226$export$8e98a1e4d2dbf1b9);
$parcel$export(module.exports, "QUICKSTART_UI_STATUS", () => (parcelRequire("7dRgX")).QUICKSTART_UI_STATUS);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
var $dYfll = parcelRequire("dYfll");

var $9CmwD = parcelRequire("9CmwD");

var $79xbN = parcelRequire("79xbN");

var $7dRgX = parcelRequire("7dRgX");

var $c8ave = parcelRequire("c8ave");

var $lCsoa = parcelRequire("lCsoa");

var $fricC = parcelRequire("fricC");

var $5OjXh = parcelRequire("5OjXh");

var $7AH2S = parcelRequire("7AH2S");
const $502e2dc73b97f226$export$390f32400eaf98c9 = (0, $a61MH.createStore)({
    name: 'jsw-onboarding-quickstart',
    initialState: $lCsoa.initialState,
    actions: $c8ave
});
const $502e2dc73b97f226$export$1cbc60d8dd921852 = (0, $dYfll.createSubscriber)($502e2dc73b97f226$export$390f32400eaf98c9);
const $502e2dc73b97f226$export$7d91c0af4772787a = (0, $ggKAj.createHook)($502e2dc73b97f226$export$390f32400eaf98c9);
const $502e2dc73b97f226$export$638bfcfce1254bb8 = (0, $heB5U.createContainer)($502e2dc73b97f226$export$390f32400eaf98c9, {});
const $502e2dc73b97f226$export$9d731f44f82af09f = (state, { itemNames: itemNames })=>{
    const commonConditionsToShowNudge = state.shouldRenderComponent && ((0, $79xbN.expValEquals)('jsm_business_quickstart', 'cohort', 'experiment') ? state.visibility[(0, $5OjXh.getQuickstartTypeSelector)(state)] === (0, $7dRgX.QUICKSTART_UI_STATUS).OPEN : state.isOpen && !state.isDismissed) && // @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
    itemNames.includes(state.openTask);
    return commonConditionsToShowNudge && state.hasNudgeActive;
};
const $502e2dc73b97f226$export$ea14030920a5d8e6 = (state)=>state.openTask;
const $502e2dc73b97f226$export$594f006fa6a1b2e5 = (0, $ggKAj.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: $502e2dc73b97f226$export$ea14030920a5d8e6
});
const $502e2dc73b97f226$export$a943afa434e9487a = (state)=>state.nudgeStep;
const $502e2dc73b97f226$export$c5e63e44ad178ae8 = (0, $ggKAj.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: $502e2dc73b97f226$export$a943afa434e9487a
});
const $502e2dc73b97f226$export$2c3cd14fff9d6e43 = (0, $ggKAj.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: null
});
const $502e2dc73b97f226$export$b0db7e46e369e1d9 = (0, $ggKAj.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: $502e2dc73b97f226$export$9d731f44f82af09f
});
// TODO: KURO-1678, delete
const $502e2dc73b97f226$var$useShouldShowOpenMenuItemHook = (0, $ggKAj.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>{
        if ((0, $79xbN.expValEquals)('jsm_business_quickstart', 'cohort', 'experiment')) return state.shouldRenderComponent && state.visibility[(0, $5OjXh.getQuickstartTypeSelector)(state)] === (0, $7dRgX.QUICKSTART_UI_STATUS).DISMISSED;
        return state.shouldRenderComponent && state.isDismissed;
    }
});
const $502e2dc73b97f226$export$d994ff8c0341aba1 = ()=>{
    const [shouldShow, { nextSetChecklistIsDismissed: nextSetChecklistIsDismissed }] = $502e2dc73b97f226$var$useShouldShowOpenMenuItemHook();
    return {
        shouldShow: shouldShow,
        setIsDismissed: nextSetChecklistIsDismissed
    };
};
const $502e2dc73b97f226$export$71de79653346a1ea = (0, $ggKAj.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>Boolean(state.projectState && state.projectState.canInvitePeopleToProject)
});
const $502e2dc73b97f226$export$61185a9266f1f57a = (0, $ggKAj.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>{
        if (!state.projectState) return false;
        const { isNextGen: isNextGen, userRole: userRole, isProjectAdmin: isProjectAdmin } = state.projectState;
        return Boolean(isNextGen && (userRole === (0, $fricC.USER_ROLE).JIRA_ADMIN || userRole === (0, $fricC.USER_ROLE).SITE_ADMIN || isProjectAdmin));
    }
});
const $502e2dc73b97f226$export$ef4747ba36826d6a = (0, $ggKAj.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>state.projectState
});
const $502e2dc73b97f226$export$522993b46d9f8266 = (0, $ggKAj.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>{
        if (state.shouldRenderComponent === false) return (0, $7dRgX.QUICKSTART_UI_STATUS).NOT_LOADED;
        const quickstartType = (0, $5OjXh.getQuickstartTypeSelector)(state);
        if ((0, $79xbN.expValEquals)('jsm_business_quickstart', 'cohort', 'experiment')) return state.visibility[quickstartType];
        if (state.isDismissed) return (0, $7dRgX.QUICKSTART_UI_STATUS).DISMISSED;
        if (state.isOpen) return (0, $7dRgX.QUICKSTART_UI_STATUS).OPEN;
        return (0, $7dRgX.QUICKSTART_UI_STATUS).MINIMIZED;
    }
});
const $502e2dc73b97f226$export$aa4ba29241532382 = (0, $ggKAj.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>state.isQuickstartLoaded
});
const $502e2dc73b97f226$export$ed5c755b733bf2b1 = (0, $ggKAj.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>state.isFocusedOn
});
const $502e2dc73b97f226$export$35fe0366802512dd = (0, $ggKAj.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>{
        if ((0, $79xbN.expValEquals)('jsm_business_quickstart', 'cohort', 'experiment')) return state.visibility[(0, $5OjXh.getQuickstartTypeSelector)(state)] === (0, $7dRgX.QUICKSTART_UI_STATUS).DISMISSED;
        return state.isDismissed;
    }
});
const $502e2dc73b97f226$export$a41ee0d3b6938099 = (0, $ggKAj.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>state.completedTaskList
});
const $502e2dc73b97f226$export$4ae7b465b076be9 = (0, $ggKAj.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>{
        if (!state.tasks) return null;
        return state.tasks.items.every((task)=>state.completedTaskList.includes(task));
    }
});
const $502e2dc73b97f226$export$bf6e646c0476acad = (0, $ggKAj.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>state.mountedNudges
});
const $502e2dc73b97f226$export$6b706bff94798d11 = (0, $ggKAj.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>state.hasEverSeenRoute
});
const $502e2dc73b97f226$export$c98db656edc5b3e1 = (0, $ggKAj.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>({
            roadmapIsCreateEnabled: state.roadmapIsCreateEnabled,
            roadmapIsListEmpty: state.roadmapIsListEmpty
        })
});
const $502e2dc73b97f226$export$a823278ac9d1112b = (0, $ggKAj.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>Boolean(state.isQuickstartLoaded && !state.isDevOpsProject && state.selectedProjectTemplateKeyFromOnboarding === (0, $9CmwD.SCRUM_TEAM_MANAGED_KEY) && state.projectState?.userRole === (0, $fricC.USER_ROLE).SITE_ADMIN)
});
const $502e2dc73b97f226$export$cb9e0e8fe4df8490 = (0, $ggKAj.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>Boolean(state.isQuickstartLoaded && !state.isDevOpsProject && state.selectedProjectTemplateKeyFromOnboarding === (0, $9CmwD.KANBAN_TEAM_MANAGED_KEY) && state.projectState?.userRole === (0, $fricC.USER_ROLE).SITE_ADMIN && // edge case - if e.g. welcome modal failed to load, and user completed task by themself, then the welcome modal should be skipped on subsequent page loads.
        !state.completedTaskList.includes((0, $7dRgX.KANBAN_ONBOARDING_TASK)))
});
const $502e2dc73b97f226$export$521909e3dc7ab811 = (0, $ggKAj.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>state.hasNudgeActive
});
const $502e2dc73b97f226$export$f4a2be940259bf95 = (0, $ggKAj.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>state.selectedProjectTemplateKeyFromOnboarding
});
const $502e2dc73b97f226$export$8e98a1e4d2dbf1b9 = (0, $ggKAj.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>state.personaExperience
});

});
parcelRegister("c8ave", function(module, exports) {

$parcel$export(module.exports, "changeTaskGroupParent", () => (parcelRequire("ah9g7")).nextChangeTaskGroupParent);
$parcel$export(module.exports, "goBackToPreviousTaskGroup", () => (parcelRequire("ah9g7")).nextGoBackToPreviousTaskGroup);
$parcel$export(module.exports, "setIsOpen", () => (parcelRequire("3TtLb")).setIsOpen);
$parcel$export(module.exports, "refreshAppState", () => (parcelRequire("agwlB")).refreshAppState);
$parcel$export(module.exports, "setNudgeStep", () => (parcelRequire("aI5eR")).setNudgeStep);
$parcel$export(module.exports, "addMountedNudge", () => (parcelRequire("1jaP6")).addMountedNudge);
$parcel$export(module.exports, "removeMountedNudge", () => (parcelRequire("1jaP6")).removeMountedNudge);
$parcel$export(module.exports, "setShouldRenderComponent", () => (parcelRequire("lCKeP")).setShouldRenderComponent);
$parcel$export(module.exports, "setProjectState", () => (parcelRequire("9FTSc")).setProjectState);
$parcel$export(module.exports, "setHasNudgeActive", () => (parcelRequire("iq74h")).setHasNudgeActive);
$parcel$export(module.exports, "forceHideNudge", () => (parcelRequire("cKB0H")).forceHideNudge);
$parcel$export(module.exports, "setHasEverSeenRoute", () => (parcelRequire("8n1zQ")).setHasEverSeenRoute);
$parcel$export(module.exports, "setRoadmapIsCreateEnabled", () => (parcelRequire("ioWKV")).setRoadmapIsCreateEnabled);
$parcel$export(module.exports, "setRoadmapIsListEmpty", () => (parcelRequire("ioWKV")).setRoadmapIsListEmpty);
$parcel$export(module.exports, "openNextTask", () => (parcelRequire("P9NN5")).openNextTask);
$parcel$export(module.exports, "resetIsQuickstartLoaded", () => (parcelRequire("6GDwI")).resetIsQuickstartLoaded);
$parcel$export(module.exports, "nextMarkAsCompletedTask", () => (parcelRequire("g1Zgk")).nextMarkAsCompletedTask);
$parcel$export(module.exports, "nextSetChecklistItemSeen", () => (parcelRequire("dn2YB")).nextSetChecklistItemSeen);
$parcel$export(module.exports, "nextSetChecklistIsDismissed", () => (parcelRequire("jssF8")).nextSetChecklistIsDismissed);
$parcel$export(module.exports, "nextSetChecklistIsOpen", () => (parcelRequire("ahbtR")).nextSetChecklistIsOpen);
$parcel$export(module.exports, "nextOpenTask", () => (parcelRequire("gn07r")).nextOpenTask);
$parcel$export(module.exports, "nextAutoExpand", () => (parcelRequire("7I9OF")).nextAutoExpand);
$parcel$export(module.exports, "nextShouldShowNudgeAfterNavigation", () => (parcelRequire("cDYe7")).nextShouldShowNudgeAfterNavigation);
$parcel$export(module.exports, "nextGetTasks", () => (parcelRequire("kDmv4")).nextGetTasks);

var $ah9g7 = parcelRequire("ah9g7");

var $3TtLb = parcelRequire("3TtLb");

var $agwlB = parcelRequire("agwlB");

var $aI5eR = parcelRequire("aI5eR");

var $1jaP6 = parcelRequire("1jaP6");

var $lCKeP = parcelRequire("lCKeP");

var $9FTSc = parcelRequire("9FTSc");

var $iq74h = parcelRequire("iq74h");

var $cKB0H = parcelRequire("cKB0H");

var $8n1zQ = parcelRequire("8n1zQ");

var $ioWKV = parcelRequire("ioWKV");

var $P9NN5 = parcelRequire("P9NN5");

var $6GDwI = parcelRequire("6GDwI");

var $g1Zgk = parcelRequire("g1Zgk");

var $dn2YB = parcelRequire("dn2YB");

var $jssF8 = parcelRequire("jssF8");

var $ahbtR = parcelRequire("ahbtR");

var $gn07r = parcelRequire("gn07r");

var $7I9OF = parcelRequire("7I9OF");

var $cDYe7 = parcelRequire("cDYe7");

var $kDmv4 = parcelRequire("kDmv4");

});
parcelRegister("ah9g7", function(module, exports) {

$parcel$export(module.exports, "nextChangeTaskGroupParent", () => $2484e60819053729$export$76708cce5888039a);
$parcel$export(module.exports, "nextGoBackToPreviousTaskGroup", () => $2484e60819053729$export$57534cbc400a434c);

var $7dRgX = parcelRequire("7dRgX");

var $8ppHd = parcelRequire("8ppHd");
const $2484e60819053729$var$setTaskGroup = (taskGroup)=>({ setState: setState })=>{
        setState({
            ...taskGroup,
            openTask: ''
        });
        (0, $8ppHd.pushToBackend)({
            key: (0, $7dRgX.KEY_TASK_GROUP),
            value: {
                taskGroup: taskGroup
            }
        });
    };
const $2484e60819053729$export$76708cce5888039a = (newCurrentTaskGroupParent)=>({ getState: getState, dispatch: dispatch })=>{
        const { previousTaskGroupParents: previousTaskGroupParents, currentTaskGroupParent: currentTaskGroupParent } = getState();
        if (previousTaskGroupParents.includes(newCurrentTaskGroupParent)) // prevent infinite loop nesting
        return;
        previousTaskGroupParents.push(currentTaskGroupParent);
        const taskGroup = {
            previousTaskGroupParents: previousTaskGroupParents,
            currentTaskGroupParent: newCurrentTaskGroupParent
        };
        dispatch($2484e60819053729$var$setTaskGroup(taskGroup));
    };
const $2484e60819053729$export$57534cbc400a434c = ()=>({ dispatch: dispatch, getState: getState })=>{
        const { previousTaskGroupParents: previousTaskGroupParents } = getState();
        const newTaskGroupParent = previousTaskGroupParents.length === 0 ? (0, $7dRgX.ROOT_TASK) : previousTaskGroupParents.pop();
        const taskGroup = {
            previousTaskGroupParents: previousTaskGroupParents,
            currentTaskGroupParent: newTaskGroupParent
        };
        // @ts-expect-error - TS2345 - Argument of type '{ previousTaskGroupParents: string[]; currentTaskGroupParent: string | undefined; }' is not assignable to parameter of type 'TaskGroup'.
        dispatch($2484e60819053729$var$setTaskGroup(taskGroup));
    };

});
parcelRegister("8ppHd", function(module, exports) {

$parcel$export(module.exports, "pushToBackend", () => $1733f663faa18bb1$export$583b2d2422a6757f);

var $48bs8 = parcelRequire("48bs8");

var $e91YZ = parcelRequire("e91YZ");

var $guiFP = parcelRequire("guiFP");

var $7EhAs = parcelRequire("7EhAs");

var $6vrw7 = parcelRequire("6vrw7");
const $1733f663faa18bb1$var$getAccountId = ()=>{
    const { atlassianAccountId: atlassianAccountId } = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)();
    if (atlassianAccountId === null) throw new Error('Atlassian Account Id is empty');
    return atlassianAccountId;
};
const $1733f663faa18bb1$var$setRemoteUserProperties = async ({ key: key, value: value })=>(0, $48bs8.setUserProperties)((0, $6vrw7.toBaseUrl)(''), $1733f663faa18bb1$var$getAccountId(), key, JSON.stringify(value)).then((response)=>{
        if (!response.ok) throw new (0, $7EhAs.default)(response.status, response.statusText);
    });
const $1733f663faa18bb1$var$trySetUserProperties = async (props, attemptCount)=>{
    try {
        await $1733f663faa18bb1$var$setRemoteUserProperties(props);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            meta: {
                id: 'pushToBackend',
                packageName: 'jiraOnboardingQuickstartCore',
                teamName: 'jlove-makkuro'
            },
            attributes: {
                action: 'pushToBackend',
                actionSubject: 'jiraOnboardingChecklistCore',
                attemptCount: attemptCount,
                key: props.key,
                reason: error && error.message
            },
            error: error
        });
        return false;
    }
    return true;
};
const $1733f663faa18bb1$export$583b2d2422a6757f = async (props)=>{
    const success = await $1733f663faa18bb1$var$trySetUserProperties(props, 1);
    if (!success) // On failure retry - if retry fails data is lost.
    await $1733f663faa18bb1$var$trySetUserProperties(props, 2);
};

});


parcelRegister("3TtLb", function(module, exports) {

$parcel$export(module.exports, "setIsOpen", () => $e2436d4b85647276$export$dcf23146e0a40195);

var $79xbN = parcelRequire("79xbN");

var $7dRgX = parcelRequire("7dRgX");

var $8ppHd = parcelRequire("8ppHd");

var $5OjXh = parcelRequire("5OjXh");
const $e2436d4b85647276$export$dcf23146e0a40195 = (isOpen)=>({ getState: getState, setState: setState })=>{
        if ((0, $79xbN.expValEquals)('jsm_business_quickstart', 'cohort', 'experiment')) {
            const state = getState();
            const quickstartType = (0, $5OjXh.getQuickstartTypeSelector)(state);
            const currentIsOpen = state.visibility[quickstartType] === (0, $7dRgX.QUICKSTART_UI_STATUS).OPEN;
            if (isOpen === currentIsOpen) // if state has not been updated we just return
            return;
            const quickstartStatus = isOpen ? (0, $7dRgX.QUICKSTART_UI_STATUS).OPEN : (0, $7dRgX.QUICKSTART_UI_STATUS).MINIMIZED;
            setState({
                visibility: {
                    ...state.visibility,
                    [quickstartType]: quickstartStatus
                }
            });
            (0, $8ppHd.pushToBackend)({
                key: (0, $7dRgX.getBackendVisibilityKey)(quickstartType),
                value: quickstartStatus
            });
            // Maintain backwards compatibility with old global quickstart in case we need to turn the feature off
            // Delete code below when cleaning up
            (0, $8ppHd.pushToBackend)({
                key: (0, $7dRgX.KEY_OPEN),
                value: isOpen
            });
            return;
        }
        /* Grab current state of is isOpen */ const { isOpen: currentIsOpen } = getState();
        if (isOpen === currentIsOpen) // if state has not been updated we just return
        return;
        setState({
            isOpen: isOpen
        });
        (0, $8ppHd.pushToBackend)({
            key: (0, $7dRgX.KEY_OPEN),
            value: isOpen
        });
    };
var $e2436d4b85647276$export$2e2bcd8739ae039 = $e2436d4b85647276$export$dcf23146e0a40195;

});
parcelRegister("5OjXh", function(module, exports) {

$parcel$export(module.exports, "getQuickstartTypeSelector", () => $6278fa6778740945$export$eae834ce0286017a);

var $7ZZxN = parcelRequire("7ZZxN");

var $7dRgX = parcelRequire("7dRgX");
const $6278fa6778740945$export$6f17f2cb816105eb = (state)=>state.projectState?.projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT);
const $6278fa6778740945$export$eae834ce0286017a = (state)=>{
    if ($6278fa6778740945$export$6f17f2cb816105eb(state)) return (0, $7dRgX.QUICKSTART_TYPE).JSM_BUSINESS_QUICKSTART_KEY;
    return (0, $7dRgX.QUICKSTART_TYPE).OLD_GLOBAL_QUICKSTART_KEY;
};

});


parcelRegister("agwlB", function(module, exports) {

$parcel$export(module.exports, "refreshAppState", () => $8d23b98670e25122$export$797c35e2e1d0d014);

var $7ZZxN = parcelRequire("7ZZxN");

var $79xbN = parcelRequire("79xbN");

var $eI5EY = parcelRequire("eI5EY");

var $9z6Oy = parcelRequire("9z6Oy");


var $jRj3P = parcelRequire("jRj3P");

var $jMP2a = parcelRequire("jMP2a");

var $4sxuP = parcelRequire("4sxuP");

var $6WXNs = parcelRequire("6WXNs");

var $7dRgX = parcelRequire("7dRgX");

var $6kCnW = parcelRequire("6kCnW");
var $8ppHd = parcelRequire("8ppHd");

var $hFK9U = parcelRequire("hFK9U");

var $lIoQU = parcelRequire("lIoQU");

var $kL6gJ = parcelRequire("kL6gJ");

var $74z6M = parcelRequire("74z6M");

var $4vWp2 = parcelRequire("4vWp2");

var $9vuWT = parcelRequire("9vuWT");

var $jssF8 = parcelRequire("jssF8");

var $ahbtR = parcelRequire("ahbtR");

var $g1Zgk = parcelRequire("g1Zgk");

var $ah9g7 = parcelRequire("ah9g7");

var $fzDyP = parcelRequire("fzDyP");
// Right now we list all the available tasks manually.
const $8d23b98670e25122$var$allTasksExcludingJSMBusinessTasks = [
    (0, $7dRgX.CREATE_PROJECT_TASK),
    (0, $7dRgX.MAP_OUT_YOUR_PROJECT_GOALS_TASK),
    (0, $7dRgX.IDENTIFY_SMALL_CHUNKS_OF_WORK_TASK),
    (0, $7dRgX.IDENTIFY_SMALL_CHUNKS_OF_WORK_KANBAN_TASK),
    (0, $7dRgX.MONITOR_MANAGE_RISK_TASK),
    (0, $7dRgX.ADD_COLUMNS_TASK),
    (0, $7dRgX.CREATE_ISSUE_TASK),
    (0, $7dRgX.CREATE_ISSUE_TASK_SIMPLIFIED),
    (0, $7dRgX.INVITE_TEAMMATES_TASK),
    (0, $7dRgX.FIND_HELP_TASK),
    (0, $7dRgX.SET_UP_BOARD_TASK),
    (0, $7dRgX.GET_MOBILE_APP_TASK),
    (0, $7dRgX.INVITE_TEAMMATES_VIDEO_TASK),
    (0, $7dRgX.CAPTURE_INTEGRATIONS_TASK),
    (0, $7dRgX.PREMIUM_REVERSE_TRIAL_TASK),
    (0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK),
    (0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN),
    (0, $7dRgX.STANDARD_EDITION_OVERVIEW_TASK),
    (0, $7dRgX.ADVANCED_ROADMAPS_TASK),
    (0, $7dRgX.CHANGE_CONTROL_TASK),
    (0, $7dRgX.AUTOMATIONS_TASK),
    (0, $7dRgX.SITE_ADMINISTRATIONS_TASK),
    (0, $7dRgX.USER_MANAGEMENT_TASK),
    (0, $7dRgX.JWM_CREATE_PROJECT_TASK),
    (0, $7dRgX.JWM_CREATE_SAMPLE_PROJECT_TASK),
    (0, $7dRgX.JWM_PROJECT_SUMMARY_TASK),
    (0, $7dRgX.JWM_GET_STARTED_LIST_TASK),
    (0, $7dRgX.JWM_BACKGROUND_COLOR_TASK),
    (0, $7dRgX.JWM_CALENDAR_TASK),
    (0, $7dRgX.JWM_TIMELINE_TASK),
    (0, $7dRgX.JWM_BUILD_FORM_TASK),
    (0, $7dRgX.JWM_FEEDBACK_TASK),
    (0, $7dRgX.JWM_SHARE_PROJECT_TASK),
    (0, $7dRgX.JWM_CREATE_YOUR_OWN_PROJECT_TASK),
    (0, $7dRgX.JWM_TRELLO_CROSSFLOW_TASK_IMPORT),
    (0, $7dRgX.JWM_SUMMARY_AND_REPORTS_TASK),
    (0, $7dRgX.JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK),
    (0, $7dRgX.JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES),
    (0, $7dRgX.JWM_FEEDBACK_SAMPLE_PROJECT_TASK),
    (0, $7dRgX.DEVOPS_WELCOME_TO_YOUR_PROJECT_TASK),
    (0, $7dRgX.DEVOPS_GET_TO_KNOW_JIRA_TASK),
    (0, $7dRgX.DEVOPS_NAVIGATE_YOUR_TOOLS_TASK),
    (0, $7dRgX.DEVOPS_CAPTURE_INTEGRATIONS_TASK),
    (0, $7dRgX.DEVOPS_CREATE_AUTOMATION_RULES_TASK),
    (0, $7dRgX.DEVOPS_INVITE_TEAMMATES_TASK),
    (0, $7dRgX.DEVOPS_FIND_HELP_TASK),
    (0, $7dRgX.SCRUM_ONBOARDING_TASK),
    (0, $7dRgX.KANBAN_ONBOARDING_TASK),
    (0, $7dRgX.CUSTOMIZE_SITE_NAME_TASK),
    (0, $7dRgX.GET_TO_KNOW_YOUR_TEMPLATE_TASK),
    (0, $7dRgX.CREATE_BUSINESS_PROJECT_FROM_JSW_QUICKSTART_TASK),
    (0, $7dRgX.TRY_ATLASSIAN_UNIVERSITY_ONBOARDING_TASK),
    (0, $7dRgX.GET_STARTED_LIST_TASK),
    (0, $7dRgX.JWM_BOARD_TASK),
    (0, $7dRgX.JWM_SUMMARY_TASK),
    (0, $7dRgX.JWM_INVITE_TEAM_TASK),
    (0, $7dRgX.JWM_PAGES_TASK),
    (0, $7dRgX.CALENDAR_VIEW_TASK)
];
const $8d23b98670e25122$var$allTasks = [
    ...$8d23b98670e25122$var$allTasksExcludingJSMBusinessTasks,
    ...(0, $7dRgX.JSM_BUSINESS_TASKS)
];
const $8d23b98670e25122$export$797c35e2e1d0d014 = ({ atlassianAccountId: atlassianAccountId, cloudId: cloudId, appEditions: appEditions, isAdmin: isAdmin, canEditPlans: canEditPlans, isAdvancedRoadmapsTrial: isAdvancedRoadmapsTrial, isTargetedForReverseTrials: isTargetedForReverseTrials, createAnalyticsEvent: createAnalyticsEvent, projectType: projectType })=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
        // Need to check to see if there is anything in the backend to take that as source of truth
        // If there is nothing then use defaults
        // Check backend for flags that are marked as completed (true)
        // Carry over state from previous actions
        // Create Completed Actions
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const updatedState = {};
        const hasSeenTasks = [
            (0, $7dRgX.convertToHaveSeenItTask)((0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK)),
            (0, $7dRgX.convertToHaveSeenItTask)((0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN)),
            (0, $7dRgX.convertToHaveSeenItTask)((0, $7dRgX.STANDARD_EDITION_OVERVIEW_TASK))
        ];
        const { projectState: projectState = null } = getState();
        // Open QS Checklist as default state if state cannot be determined from the backend
        updatedState.isOpen = true;
        updatedState.isDismissed = false;
        let backendVisibilityKeys = [];
        let jsmTaskProjectKeys = [];
        if ((0, $79xbN.expValEquals)('jsm_business_quickstart', 'cohort', 'experiment')) {
            // Open QS Checklist as default state if state cannot be determined from the backend
            updatedState.visibility = Object.values((0, $7dRgX.QUICKSTART_TYPE)).reduce((acc, type)=>{
                acc[type] = (0, $7dRgX.QUICKSTART_UI_STATUS).OPEN;
                return acc;
            }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            {});
            backendVisibilityKeys = Object.values((0, $7dRgX.QUICKSTART_TYPE)).map((type)=>(0, $7dRgX.getBackendVisibilityKey)(type));
            if (projectState?.projectId) jsmTaskProjectKeys = (0, $7dRgX.JSM_BUSINESS_TASKS).map((task)=>`${task}.${projectState?.projectId}`);
        }
        const backendState = await (0, $6kCnW.pollBackend)({
            keys: [
                (0, $7dRgX.KEY_OPEN),
                (0, $7dRgX.KEY_DISMISSED),
                (0, $7dRgX.KEY_OPEN_TASK),
                (0, $7dRgX.KEY_TASK_GROUP),
                (0, $7dRgX.KEY_HAS_EVER_SEEN_ROUTE),
                (0, $7dRgX.KEY_JSW_ONBOARDING),
                (0, $7dRgX.KEY_PREMIUM_TRIAL_REOPENED),
                ...$8d23b98670e25122$var$allTasks,
                ...hasSeenTasks,
                ...backendVisibilityKeys,
                ...jsmTaskProjectKeys
            ]
        });
        if (projectState && projectState.projectKey) updatedState.isDevOpsProject = await (0, $74z6M.getIsDevOpsProject)(projectState.projectKey);
        const backendStateExists = backendState !== undefined && Object.keys(backendState).length > 0;
        if (backendStateExists) {
            updatedState.completedTaskList = (0, $79xbN.expValEquals)('jsm_business_quickstart', 'cohort', 'experiment') ? Object.keys(backendState).filter((key)=>[
                    ...$8d23b98670e25122$var$allTasksExcludingJSMBusinessTasks,
                    ...jsmTaskProjectKeys
                ].includes(key) && backendState[key] === true) : Object.keys(backendState).filter((key)=>$8d23b98670e25122$var$allTasks.includes(key) && backendState[key] === true);
            updatedState.hasSeenTasks = hasSeenTasks.filter((key)=>backendState[key] === true);
            if ((0, $79xbN.expValEquals)('jsm_business_quickstart', 'cohort', 'experiment')) Object.values((0, $7dRgX.QUICKSTART_TYPE)).forEach((type)=>{
                // use new state if possible
                if ((0, $7dRgX.getBackendVisibilityKey)(type) in backendState) updatedState.visibility[type] = backendState[(0, $7dRgX.getBackendVisibilityKey)(type)];
                else if ((0, $7dRgX.KEY_DISMISSED) in backendState && backendState[0, $7dRgX.KEY_DISMISSED]) updatedState.visibility[type] = (0, $7dRgX.QUICKSTART_UI_STATUS).DISMISSED;
                else if ((0, $7dRgX.KEY_OPEN) in backendState) updatedState.visibility[type] = backendState[0, $7dRgX.KEY_OPEN] ? (0, $7dRgX.QUICKSTART_UI_STATUS).OPEN : (0, $7dRgX.QUICKSTART_UI_STATUS).MINIMIZED;
            });
            if ((0, $7dRgX.KEY_DISMISSED) in backendState) updatedState.isDismissed = backendState[0, $7dRgX.KEY_DISMISSED];
            if ((0, $7dRgX.KEY_OPEN) in backendState) updatedState.isOpen = backendState[0, $7dRgX.KEY_OPEN];
            if ((0, $7dRgX.KEY_OPEN_TASK) in backendState) updatedState.openTask = backendState[0, $7dRgX.KEY_OPEN_TASK];
            if ((0, $7dRgX.KEY_HAS_EVER_SEEN_ROUTE) in backendState) updatedState.hasEverSeenRoute = backendState[0, $7dRgX.KEY_HAS_EVER_SEEN_ROUTE];
            if ((0, $7dRgX.KEY_TASK_GROUP) in backendState) {
                updatedState.currentTaskGroupParent = // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                backendState[0, $7dRgX.KEY_TASK_GROUP].taskGroup.currentTaskGroupParent;
                updatedState.previousTaskGroupParents = // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                backendState[0, $7dRgX.KEY_TASK_GROUP].taskGroup.previousTaskGroupParents;
            }
            if ((0, $7dRgX.KEY_JSW_ONBOARDING) in backendState) {
                if (typeof backendState[0, $7dRgX.KEY_JSW_ONBOARDING] === 'object' && backendState[0, $7dRgX.KEY_JSW_ONBOARDING] !== null && (0, $8379f5d78bf6fb5a$export$8a00ecf6498ee2fe) in backendState[0, $7dRgX.KEY_JSW_ONBOARDING]) updatedState.selectedProjectTemplateKeyFromOnboarding = backendState[0, $7dRgX.KEY_JSW_ONBOARDING][0, $8379f5d78bf6fb5a$export$8a00ecf6498ee2fe];
            }
        }
        if (atlassianAccountId && projectType === (0, $7ZZxN.CORE_PROJECT) && (0, $hFK9U.isUserEnrolledInTailoredOnboardingExperiment)()) try {
            const userTraits = await (0, $jRj3P.memoizedFetchSiteUserPersonalization)({
                cloudId: cloudId,
                userId: atlassianAccountId
            });
            const userTraitsPersona = userTraits?.find((trait)=>trait.name === (0, $4vWp2.PERSONA_TRAIT_NAME));
            const personaExperience = (0, $fzDyP.mapPersonaTraitsToExperience)(userTraitsPersona);
            const analyticsEvent = createAnalyticsEvent({});
            (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'refreshAppState settingPersonaExperienceFromTraits', {
                personaExperience: personaExperience,
                persona: userTraitsPersona?.value,
                tailoredOnboardingExperiment1: (0, $hFK9U.getTailoredOnboardingExperimentCohort)()
            });
            if (personaExperience) updatedState.personaExperience = personaExperience;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $lIoQU.fireAPIErrorAnalytics)(error, 'fetchSiteUserPersonalization');
        }
        // Important that this call is before the dismiss migration logic and the premium card permission migration, otherwise it would
        // override the dismiss and currentTaskGroupParent
        setState(updatedState);
        // Bit of a migration
        // Handles case where non-admin premium users have a premium card child open which they can no longer access as we added more permission checks
        // Or, if a user was on a premium trial and saw premium content but is now free,
        // We take them to the root instead
        if ((updatedState.currentTaskGroupParent === (0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN) || updatedState.currentTaskGroupParent === (0, $7dRgX.PREMIUM_REVERSE_TRIAL_TASK)) && !canEditPlans || (updatedState.currentTaskGroupParent === (0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK) || updatedState.currentTaskGroupParent === (0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN) || updatedState.currentTaskGroupParent === (0, $7dRgX.PREMIUM_REVERSE_TRIAL_TASK)) && appEditions.software !== (0, $6WXNs.PREMIUM_EDITION)) {
            dispatch((0, $ah9g7.nextGoBackToPreviousTaskGroup)());
            const analyticsEvent = createAnalyticsEvent({});
            (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'refreshAppState premiumCardPermissionsRevoked');
        }
        if (!(backendStateExists && (0, $7dRgX.KEY_OPEN) in backendState)) try {
            const skipApplicationProperty = await (0, $9vuWT.getOnboardingSkipApplicationProperty)();
            if (skipApplicationProperty.quickstart) dispatch((0, $jssF8.nextSetChecklistIsDismissed)(true));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $lIoQU.fireAPIErrorAnalytics)(error, 'skipOnboarding');
        }
        const jswTrackDeferSitenameSiteTrait = await (0, $9z6Oy.getJswTrackDeferSitenameSiteTrait)(cloudId, {
            packageName: (0, $7dRgX.PACKAGE_NAME),
            teamName: (0, $7dRgX.PACKAGE_TEAM_NAME)
        });
        setState({
            isEligibleToUpdateSitename: jswTrackDeferSitenameSiteTrait?.value === 'experiment-generated-site-name'
        });
        const setPremiumCardAudienceTrait = async (accountId)=>{
            if (accountId === null) return;
            const trait = await (0, $kL6gJ.getCrossProjectBoardTrait)(createAnalyticsEvent, cloudId, accountId);
            setState({
                isCrossProjectBoardToPlanUpsell: trait?.value === true || false
            });
        };
        // We only want to check if a non-admin user has the CPB trait if they are in a
        // premium evaluation of jira software (i.e. they have access to Advanced Roadmaps)
        if (appEditions.software === (0, $6WXNs.PREMIUM_EDITION) && !isAdmin) await setPremiumCardAudienceTrait(atlassianAccountId);
        const { isCrossProjectBoardToPlanUpsell: isCrossProjectBoardToPlanUpsell } = getState();
        // If the user is on a JSW Premium instance, perform a fetch to check that they signed up with a Premium Reverse Trial.
        let isReverseTrialForJSW;
        if (isTargetedForReverseTrials && (0, $eI5EY.fg)('jsw_reverse_trials_feature_gate')) {
            const isOnboardingPremiumTrial = await (0, $4sxuP.getOnboardingPremiumTrial)();
            isReverseTrialForJSW = isOnboardingPremiumTrial?.premiumTrialOnSignup;
        }
        /**
		 * Re-open QS for:
		 *  - admins on an AdvancedRoadmaps trial who haven't had it re-opened for them yet
		 *  - non-admins on an AdvancedRoadmaps trial with isCrossProjectBoardToPlanUpsell trait
		 */ // eslint-disable-next-line jira/ff/unsafe-no-exposure
        const [simplifyKanbanQsExpConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_simplify_kanban_qs');
        // eslint-disable-next-line jira/ff/unsafe-no-exposure
        const [disableAutoNudgeTour] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_disable_auto_nudge_tours');
        // eslint-disable-next-line jira/ff/unsafe-no-exposure
        const [simplifyKanbanQsForAllExpConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_simplify_kanban_qs_all_users');
        const shouldSimplifyKanbanQs = simplifyKanbanQsForAllExpConfig.get('isEnabled', false) || disableAutoNudgeTour.get('isDisabled', false) && simplifyKanbanQsExpConfig.get('cohort', 'not-enrolled') === 'variation';
        if (!shouldSimplifyKanbanQs && !isReverseTrialForJSW && appEditions.software === (0, $6WXNs.PREMIUM_EDITION) && isAdvancedRoadmapsTrial && (isAdmin || isCrossProjectBoardToPlanUpsell) && atlassianAccountId != null && !backendState[0, $7dRgX.KEY_PREMIUM_TRIAL_REOPENED]) {
            // Re-open QS if not already opened
            dispatch((0, $ahbtR.nextSetChecklistIsOpen)(true));
            dispatch((0, $jssF8.nextSetChecklistIsDismissed)(false));
            const taskToDispatch = isAdmin ? (0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK) : (0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN);
            // Go to advanced roadmaps task
            dispatch((0, $g1Zgk.nextMarkAsCompletedTask)(taskToDispatch));
            dispatch((0, $ah9g7.nextChangeTaskGroupParent)(taskToDispatch));
            await (0, $8ppHd.pushToBackend)({
                key: (0, $7dRgX.KEY_PREMIUM_TRIAL_REOPENED),
                value: true
            });
            const analyticsEvent = createAnalyticsEvent({});
            (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'advancedRoadmapsTask reopened', {
                isAdmin: isAdmin
            });
        }
        setState({
            canEditPlans: canEditPlans
        });
        setState({
            isQuickstartLoaded: true
        });
    };

});
parcelRegister("9z6Oy", function(module, exports) {

$parcel$export(module.exports, "getSignupTrackDeferSitenameUserTrait", () => $d04aec276ef38a16$export$686752df505238be);
$parcel$export(module.exports, "getJswTrackDeferSitenameSiteTrait", () => $d04aec276ef38a16$export$6da79f996c267010);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");
const $d04aec276ef38a16$var$PERSONALIZATION_ENDPOINT = '/gateway/api/tap-delivery/api/v3/personalization';
const $d04aec276ef38a16$var$SITE_PERSONALIZATION_ENDPOINT = `${$d04aec276ef38a16$var$PERSONALIZATION_ENDPOINT}/site/`;
const $d04aec276ef38a16$var$USER_PERSONALIZATION_ENDPOINT = `${$d04aec276ef38a16$var$PERSONALIZATION_ENDPOINT}/user/`;
const $d04aec276ef38a16$var$SIGNUP_TRACK_DEFER_SITENAME_USER_TRAIT = 'marketing-signup_track_deferred-sitename_signup_server_enrollment';
const $d04aec276ef38a16$var$JSW_TRACK_DEFER_SITENAME_TRAIT = 'jira_track_instance_created_server_defer_site_rename_cohort';
const $d04aec276ef38a16$var$fetchPersonalization = (endpoint, subject)=>async (id, meta)=>{
        try {
            const url = endpoint + id;
            return await (0, $lRmyA.performGetRequest)(url);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                meta: {
                    id: 'onboarding',
                    teamName: 'jlove-makkuro',
                    ...meta
                },
                attributes: {
                    subject: subject
                },
                error: error
            });
            return undefined;
        }
    };
const $d04aec276ef38a16$var$getTraits = (fetch, traitName)=>async (id, meta)=>{
        const personalization = await fetch(id, meta);
        return personalization?.attributes.find((att)=>att.name === traitName);
    };
const $d04aec276ef38a16$export$686752df505238be = $d04aec276ef38a16$var$getTraits($d04aec276ef38a16$var$fetchPersonalization($d04aec276ef38a16$var$USER_PERSONALIZATION_ENDPOINT, 'fetchUserPersonalization'), $d04aec276ef38a16$var$SIGNUP_TRACK_DEFER_SITENAME_USER_TRAIT);
const $d04aec276ef38a16$export$6da79f996c267010 = $d04aec276ef38a16$var$getTraits($d04aec276ef38a16$var$fetchPersonalization($d04aec276ef38a16$var$SITE_PERSONALIZATION_ENDPOINT, 'fetchSitePersonalization'), $d04aec276ef38a16$var$JSW_TRACK_DEFER_SITENAME_TRAIT);

});

// Session storage constants used between going through initial onboarding screens
// and landing in JIRA
// Note this key used to be 'should-show-scrum-modal' but was changed to prevent a bug where experienced users
// Could see the modal if they were previously enrolled into ISO
const $8379f5d78bf6fb5a$export$67abe0a3b8dfe03f = 'should-show-scrum-modal-v2';
const $8379f5d78bf6fb5a$export$4e1360a3e7785935 = 'should-show-kanban-modal';
const $8379f5d78bf6fb5a$export$e3884212029f7bef = 'should-show-welcome-modal';
const $8379f5d78bf6fb5a$export$928ffae10e4c0006 = 'template-key-to-show-onboarding-modal';
const $8379f5d78bf6fb5a$export$8a00ecf6498ee2fe = 'onboarding-selected-project-template-type';
const $8379f5d78bf6fb5a$export$69fe8832c4f79a32 = 'onboarding_started_timestamp';
const $8379f5d78bf6fb5a$export$a8d62e500b59f31e = 'boardCreateColumnButtonNudge';
const $8379f5d78bf6fb5a$export$92c7f0eacc8d8d98 = 'assigneeFilterAddPeopleButtonNudge';
const $8379f5d78bf6fb5a$export$dd63d0099d95ba4f = 'navigationAppsNavItemNudge';
const $8379f5d78bf6fb5a$export$aba87e019f5ccb8d = 'navigationCreateIssueButtonNudge';
const $8379f5d78bf6fb5a$export$46d9a3d441dfd22b = 'navigationPlansNavItemNudge';
const $8379f5d78bf6fb5a$export$e20072f7d0c5357f = 'roadmapCreateEpicButtonNudge';
const $8379f5d78bf6fb5a$export$1e39959907a7f359 = 'roadmapCreateEpicChildIssueButtonNudge';
const $8379f5d78bf6fb5a$export$b74a8fdb2c75b869 = 'navigationPeopleNavItemNudge';
const $8379f5d78bf6fb5a$export$b1a6ab17737f33e = 'backlogAccordionNudge';
const $8379f5d78bf6fb5a$export$de67e10f0021c605 = 'backlogAddWorkNudge';
const $8379f5d78bf6fb5a$export$b0f5daf4a27dcdf0 = 'listAddWorkNudge';
const $8379f5d78bf6fb5a$export$d99efc8157056bed = 'timelineAddWorkNudge';
const $8379f5d78bf6fb5a$export$3366ddefe77d5112 = 'boardCreateColumnNudge';
const $8379f5d78bf6fb5a$export$9d9e95a66a2c6abe = 'addItemsCalendarNudge';
const $8379f5d78bf6fb5a$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $8379f5d78bf6fb5a$export$dd4b359b5a58cdc0 = 'trelloCrossflowTimelineTabNudge';
const $8379f5d78bf6fb5a$export$7aa8bceae32c7862 = 'navigationAppsProfileItemNudge';
const $8379f5d78bf6fb5a$export$c6df9a2c7447e12d = 'getStartedListNudge';
const $8379f5d78bf6fb5a$export$468488291ccd988 = 'timelineAddItemNudge';
const $8379f5d78bf6fb5a$export$7a33548109ac931d = 'createFormNudge';
const $8379f5d78bf6fb5a$export$b65ba9ea0c0ced43 = 'jsw-onboarding-checklist.open';
const $8379f5d78bf6fb5a$export$594d3436316492be = 'summaryViewNudge';
const $8379f5d78bf6fb5a$export$77bc79debbf5c069 = 'inviteTeamNudge';
const $8379f5d78bf6fb5a$export$73278890f736ee6f = 'manageProjectsNudge';

parcelRegister("jRj3P", function(module, exports) {

$parcel$export(module.exports, "memoizedFetchSiteUserPersonalization", () => $4441cad18cc93774$export$de93ec54b11be450);
$parcel$export(module.exports, "useSiteUserPersonalization", () => $4441cad18cc93774$export$8dc79ff315095801);

var $5iWql = parcelRequire("5iWql");

var $eEzyV = parcelRequire("eEzyV");

var $2OdyW = parcelRequire("2OdyW");
const $4441cad18cc93774$var$getPersonalizationSiteUserTraitsUrl = (cloudId, userId)=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`;
const $4441cad18cc93774$export$8f40704723ec6690 = async ({ cloudId: cloudId, userId: userId })=>{
    if (!cloudId) throw new Error('empty cloudId');
    if (!userId) throw new Error('empty userId');
    const { attributes: attributes } = await (0, $2OdyW.default)($4441cad18cc93774$var$getPersonalizationSiteUserTraitsUrl(cloudId, userId), {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'x-atlassian-mau-ignore': 'true'
        }
    });
    return attributes;
};
const $4441cad18cc93774$export$de93ec54b11be450 = (0, $5iWql.default)($4441cad18cc93774$export$8f40704723ec6690, ([{ cloudId: newCloudId, userId: newUserId }], [{ cloudId: lastCloudId, userId: lastUserId }])=>newCloudId === lastCloudId && newUserId === lastUserId);
const $4441cad18cc93774$export$8dc79ff315095801 = ()=>(0, $eEzyV.useService)($4441cad18cc93774$export$de93ec54b11be450);

});

parcelRegister("6kCnW", function(module, exports) {

$parcel$export(module.exports, "pollBackend", () => $72b53773fb858e3c$export$8420ef0cee98de);

var $95f8K = parcelRequire("95f8K");

var $6vrw7 = parcelRequire("6vrw7");

var $7dRgX = parcelRequire("7dRgX");
const $72b53773fb858e3c$export$8420ef0cee98de = async ({ keys: keys })=>{
    const { user: user } = await (0, $95f8K.get)((0, $6vrw7.toBaseUrl)(''), {
        userProperties: keys,
        consumerMeta: {
            id: 'fetchUserProperties',
            packageName: (0, $7dRgX.PACKAGE_NAME),
            teamName: (0, $7dRgX.PACKAGE_TEAM_NAME)
        }
    });
    return user;
};

});
parcelRegister("95f8K", function(module, exports) {

$parcel$export(module.exports, "get", () => $4b3de6acfae5f7c4$export$3988ae62b71be9a3);

var $fUTZC = parcelRequire("fUTZC");

var $4vTMF = parcelRequire("4vTMF");

var $guiFP = parcelRequire("guiFP");

var $JRB5w = parcelRequire("JRB5w");
var $lRmyA = parcelRequire("lRmyA");

var $3FyZ4 = parcelRequire("3FyZ4");

var $12kyE = parcelRequire("12kyE");
var $kDfSL = parcelRequire("kDfSL");
let $4b3de6acfae5f7c4$var$ufoExperiencesMap = {};
const $4b3de6acfae5f7c4$var$getUfoExperience = (key)=>{
    if (!$4b3de6acfae5f7c4$var$ufoExperiencesMap[key]) $4b3de6acfae5f7c4$var$ufoExperiencesMap[key] = new (0, $kDfSL.UFOExperience)(key, {
        type: (0, $12kyE.ExperienceTypes).Operation,
        performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom
    });
    return $4b3de6acfae5f7c4$var$ufoExperiencesMap[key];
};
const $4b3de6acfae5f7c4$export$c907f169d33b2e25 = ()=>{
    $4b3de6acfae5f7c4$var$ufoExperiencesMap = {};
};
const $4b3de6acfae5f7c4$export$a5b7a8c3b1c6e775 = (baseUrl, { userProperties: userProperties, projectId: projectId, projectProperties: projectProperties, instanceProperties: instanceProperties })=>{
    const params = new URLSearchParams();
    userProperties && params.append('user', userProperties.join(','));
    projectId !== undefined && params.append('projectId', projectId);
    projectProperties && params.append('project', projectProperties.join(','));
    instanceProperties && params.append('instance', instanceProperties.join(','));
    return `/rest/internal/latest/frontendconfig/properties?${params.toString()}`;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $4b3de6acfae5f7c4$var$patchProperties = (response, propertiesPath)=>(0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(response[propertiesPath], (value, prop)=>{
        try {
            response[propertiesPath][prop] = JSON.parse(value);
        } catch (error) {
            // TODO: Endpoint should ideally only return stringified values
            if (prop === 'initial.project.template.name') response[propertiesPath][prop] = value;
            else throw error;
        }
    });
const $4b3de6acfae5f7c4$export$3988ae62b71be9a3 = async (baseUrl, options)=>{
    const ufoExperience = $4b3de6acfae5f7c4$var$getUfoExperience(`${(0, (/*@__PURE__*/$parcel$interopDefault($4vTMF)))(options.consumerMeta.packageName)}.${(0, (/*@__PURE__*/$parcel$interopDefault($4vTMF)))(options.consumerMeta.id)}`);
    try {
        ufoExperience?.start();
        const url = $4b3de6acfae5f7c4$export$a5b7a8c3b1c6e775(baseUrl, options);
        const response = await (0, $lRmyA.performGetRequest)(url);
        $4b3de6acfae5f7c4$var$patchProperties(response, 'user');
        $4b3de6acfae5f7c4$var$patchProperties(response, 'instance');
        $4b3de6acfae5f7c4$var$patchProperties(response, 'project');
        const { consumerMeta: consumerMeta } = options;
        (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
            const payload = {
                source: 'frontendConfigProperties',
                action: 'success',
                actionSubject: `${consumerMeta.packageName}.${consumerMeta.id}`
            };
            client.getInstance().sendOperationalEvent(payload);
        });
        ufoExperience?.success();
        return response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        const { consumerMeta: consumerMeta } = options;
        !(0, $JRB5w.isClientFetchError)(error) && (0, $guiFP.default)({
            error: error,
            meta: {
                id: consumerMeta.id,
                packageName: consumerMeta.packageName,
                teamName: consumerMeta.teamName
            },
            sendToPrivacyUnsafeSplunk: true
        });
        ufoExperience?.failure();
        throw error;
    }
};

});


parcelRegister("hFK9U", function(module, exports) {

$parcel$export(module.exports, "getTailoredOnboardingExperimentCohort", () => $7643a0c0824fb12c$export$fcb264347c366122);
$parcel$export(module.exports, "isUserEnrolledInTailoredOnboardingExperiment", () => $7643a0c0824fb12c$export$7b8159a372d92686);
$parcel$export(module.exports, "isTailoredQuickstartEnabled", () => $7643a0c0824fb12c$export$65a9481ea376f1be);

var $79xbN = parcelRequire("79xbN");

var $eI5EY = parcelRequire("eI5EY");

var $4vWp2 = parcelRequire("4vWp2");
const $7643a0c0824fb12c$export$fcb264347c366122 = ()=>{
    const [expConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jwm_tailored_onboarding');
    return expConfig.get('cohort', 'not-enrolled');
};
const $7643a0c0824fb12c$export$7b8159a372d92686 = ()=>{
    if ((0, $eI5EY.fg)('jwm_tailored_onboarding_gate')) {
        const userCohort = $7643a0c0824fb12c$export$fcb264347c366122();
        return userCohort !== 'not-enrolled';
    }
    return false;
};
const $7643a0c0824fb12c$export$65a9481ea376f1be = (personaExperience)=>Boolean(personaExperience && (0, $4vWp2.SUPPORTED_PERSONA_EXPERIENCES).includes(personaExperience) && (0, $79xbN.expValEquals)('jwm_tailored_onboarding', 'cohort', 'variation'));

});
parcelRegister("4vWp2", function(module, exports) {

$parcel$export(module.exports, "EXPERIENCE_TYPE", () => $9d1a089e61b3d8e4$export$19cb56bee281315d);
$parcel$export(module.exports, "PERSONA_TYPE", () => $9d1a089e61b3d8e4$export$4fea3380347f1b0);
$parcel$export(module.exports, "PERSONA_TRAIT_NAME", () => $9d1a089e61b3d8e4$export$8cfac46d1cf13d0d);
$parcel$export(module.exports, "SUPPORTED_PERSONA_EXPERIENCES", () => $9d1a089e61b3d8e4$export$cbc64427de2881a9);
const $9d1a089e61b3d8e4$export$19cb56bee281315d = {
    MARKETER_LEAD: 'Campaign Management Marketing Lead',
    MARKETER_PROJECT: 'Project Management Marketing Lead',
    MARKETER_CONTENT: 'Content Management Content Marketer',
    MARKETER_PMM: 'Project Management PMM'
};
const $9d1a089e61b3d8e4$export$4fea3380347f1b0 = {
    MARKETING_GENERIC: 'Marketing Generic',
    PROJECT_MARKETING_LEAD: 'Project Management Marketing Lead',
    CAMPAIGN_MARKETING_LEAD: 'Campaign Management Marketing Lead',
    CONTENT_MARKETING_LEAD: 'Content Management Content Marketer',
    PMM: 'Project Management PMM'
};
const $9d1a089e61b3d8e4$export$8cfac46d1cf13d0d = 'marketing_track_tailored_onboarding_initialized_wacprovisioningscreen_changed';
const $9d1a089e61b3d8e4$export$cbc64427de2881a9 = [
    $9d1a089e61b3d8e4$export$19cb56bee281315d.MARKETER_LEAD,
    $9d1a089e61b3d8e4$export$19cb56bee281315d.MARKETER_PROJECT,
    $9d1a089e61b3d8e4$export$19cb56bee281315d.MARKETER_CONTENT,
    $9d1a089e61b3d8e4$export$19cb56bee281315d.MARKETER_PMM
];

});


parcelRegister("lIoQU", function(module, exports) {

$parcel$export(module.exports, "fireAnalyticsOnQuickstartClose", () => $d6df15178ffe1f85$export$c98a6ee6aadb8055);
$parcel$export(module.exports, "fireAnalyticsOnQuickstartDismiss", () => $d6df15178ffe1f85$export$45d8c76e0490b3ec);
$parcel$export(module.exports, "fireAnalyticsOnQuickstartBack", () => $d6df15178ffe1f85$export$b1be4ae35a43115d);
$parcel$export(module.exports, "fireAnalyticsOnQuickstartExperienceComplete", () => $d6df15178ffe1f85$export$fa4f266bd2444d14);
$parcel$export(module.exports, "fireAnalyticsOnChecklistItemCompleted", () => $d6df15178ffe1f85$export$a68a2e5a69c8cd74);
$parcel$export(module.exports, "fireAPIErrorAnalytics", () => $d6df15178ffe1f85$export$a4d7f1a52677d339);
$parcel$export(module.exports, "fireAnalyticsOnOpenRightHandSidebar", () => $d6df15178ffe1f85$export$160bb78a3b11a5a9);
$parcel$export(module.exports, "fireAnalyticsOnMinimiseRightHandSidebar", () => $d6df15178ffe1f85$export$6ccbe54cd3a5a12);
$parcel$export(module.exports, "fireAnalyticsOnCloseRightHandSidebar", () => $d6df15178ffe1f85$export$6c39ca65ca354e59);

var $guiFP = parcelRequire("guiFP");

var $jMP2a = parcelRequire("jMP2a");

var $7dRgX = parcelRequire("7dRgX");
parcelRequire("bnszi");
var $eVkIs = parcelRequire("eVkIs");
const $d6df15178ffe1f85$export$c98a6ee6aadb8055 = (analyticsEvent, attributes)=>{
    analyticsEvent.update({
        action: 'closed',
        actionSubject: 'button'
    });
    (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'button closed', (0, $7dRgX.ACTION_SUBJECT_ID), attributes);
};
const $d6df15178ffe1f85$export$45d8c76e0490b3ec = (analyticsEvent, attributes, source)=>{
    if (source === 'button') (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'button clicked', 'dismissQuickstartButton', attributes);
    else if (source === 'checklist') (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'button clicked', 'dismissQuickstart', attributes);
};
const $d6df15178ffe1f85$export$b1be4ae35a43115d = (analyticsEvent)=>{
    (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'button clicked', 'backButton');
};
const $d6df15178ffe1f85$export$fa4f266bd2444d14 = (createAnalyticsEvent, attributes)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'experience completed', (0, $7dRgX.ACTION_SUBJECT_ID), {
        ...attributes
    });
};
const $d6df15178ffe1f85$export$a68a2e5a69c8cd74 = (createAnalyticsEvent, completedTaskId)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'checklistItem completed', (0, $eVkIs.convertTaskIdToActionSubjectId)(completedTaskId), {
        taskId: completedTaskId
    });
};
const $d6df15178ffe1f85$export$a4d7f1a52677d339 = (error, endpointSource)=>{
    (0, $guiFP.default)({
        error: error,
        meta: {
            id: 'quickstartApiError',
            packageName: 'jiraOnboardingQuickstartCore',
            teamName: 'jlove-makkuro'
        },
        attributes: {
            error: error.message,
            endpointSource: endpointSource
        }
    });
};
const $d6df15178ffe1f85$export$160bb78a3b11a5a9 = (createAnalyticsEvent, attributes)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'nuxOnboardingQuickstart openRightSidebar', (0, $7dRgX.ACTION_SUBJECT_ID), {
        ...attributes
    });
};
const $d6df15178ffe1f85$export$6ccbe54cd3a5a12 = (createAnalyticsEvent, attributes)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'nuxOnboardingQuickstart minimiseRightSidebar', (0, $7dRgX.ACTION_SUBJECT_ID), {
        ...attributes
    });
};
const $d6df15178ffe1f85$export$6c39ca65ca354e59 = (createAnalyticsEvent, attributes)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'nuxOnboardingQuickstart closeRightSidebar', (0, $7dRgX.ACTION_SUBJECT_ID), {
        ...attributes
    });
};

});
parcelRegister("bnszi", function(module, exports) {

$parcel$export(module.exports, "getTaskIndex", () => $1a376c852d3b72fa$export$9ba3adcb1954c00);
$parcel$export(module.exports, "convertTaskIdToActionSubjectIdForShowMe", () => $1a376c852d3b72fa$export$9711f11998d5795c);
$parcel$export(module.exports, "convertTaskIdToActionSubjectIdForLink", () => $1a376c852d3b72fa$export$995248f3b43d8505);
$parcel$export(module.exports, "convertTaskIdToActionSubjectIdForCta", () => $1a376c852d3b72fa$export$293f6b2affa6ea5a);
$parcel$export(module.exports, "convertTaskIdToActionSubjectId", () => (parcelRequire("eVkIs")).convertTaskIdToActionSubjectId);

var $eVkIs = parcelRequire("eVkIs");

var $8ppHd = parcelRequire("8ppHd");

var $6kCnW = parcelRequire("6kCnW");

var $cY793 = parcelRequire("cY793");

var $jTgI9 = parcelRequire("jTgI9");

var $6JZfU = parcelRequire("6JZfU");

var $iZV3I = parcelRequire("iZV3I");
const $1a376c852d3b72fa$export$9ba3adcb1954c00 = (taskList, taskId)=>{
    if (!taskList || taskId === null) return -1;
    return taskList.indexOf(taskId) + 1;
};
const $1a376c852d3b72fa$export$9711f11998d5795c = (taskId)=>`${(0, $eVkIs.convertTaskIdToActionSubjectId)(taskId)}ShowMe`;
const $1a376c852d3b72fa$export$995248f3b43d8505 = (taskId)=>`${(0, $eVkIs.convertTaskIdToActionSubjectId)(taskId)}Link`;
const $1a376c852d3b72fa$export$293f6b2affa6ea5a = (taskId)=>`${(0, $eVkIs.convertTaskIdToActionSubjectId)(taskId)}Cta`;

});
parcelRegister("eVkIs", function(module, exports) {

$parcel$export(module.exports, "getProductType", () => $0947b77be3ed825c$export$27e53caf66bae1d);
$parcel$export(module.exports, "convertTaskIdToActionSubjectId", () => $0947b77be3ed825c$export$3b914201960fa7a6);

var $jh2R9 = parcelRequire("jh2R9");

var $7ZZxN = parcelRequire("7ZZxN");
const $0947b77be3ed825c$export$d64a7dd8c7cd80e0 = {
    [(0, $7ZZxN.CORE_PROJECT)]: 'workManagement',
    [(0, $7ZZxN.SOFTWARE_PROJECT)]: 'software',
    [(0, $7ZZxN.SERVICE_DESK_PROJECT)]: 'serviceManagement'
};
const $0947b77be3ed825c$export$27e53caf66bae1d = (projectType)=>{
    if (projectType) return $0947b77be3ed825c$export$d64a7dd8c7cd80e0[projectType] || (0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))(projectType);
    return null;
};
const $0947b77be3ed825c$export$3b914201960fa7a6 = (taskId)=>{
    if (!taskId) return '';
    return (0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))(taskId.split('.').pop());
};

});

parcelRegister("cY793", function(module, exports) {

$parcel$export(module.exports, "localStorageProvider", () => $f403f41047806be6$export$aa821bfb3308a1f5);
$parcel$export(module.exports, "setLocalStorageHasNavigatedFromLink", () => $f403f41047806be6$export$f2666fae743fa5f);

var $89bO2 = parcelRequire("89bO2");

var $guiFP = parcelRequire("guiFP");

var $7dRgX = parcelRequire("7dRgX");
const $f403f41047806be6$var$DAYS_BEFORE_EXPIRY = 1;
const $f403f41047806be6$var$DAY = 86400000;
const $f403f41047806be6$var$getKey = ({ accountId: accountId, key: key })=>`${accountId}.${key}`;
const $f403f41047806be6$var$getExpiryTime = ()=>{
    const now = Date.now();
    return now + $f403f41047806be6$var$DAYS_BEFORE_EXPIRY * $f403f41047806be6$var$DAY;
};
let $f403f41047806be6$var$localStorage;
const $f403f41047806be6$export$aa821bfb3308a1f5 = ()=>{
    if ($f403f41047806be6$var$localStorage) return $f403f41047806be6$var$localStorage;
    const provider = (0, $89bO2.createSessionExpirableStorageProvider)('jsw-onboarding-checklist');
    try {
        provider.removeExpiredKeys();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $guiFP.default)({
            meta: {
                id: 'localStorageProviderKeyRemoval',
                packageName: 'jiraOnboardingQuickstartCore'
            },
            error: e
        });
    }
    const get = ({ accountId: accountId, key: key })=>provider.get($f403f41047806be6$var$getKey({
            accountId: accountId,
            key: key
        }));
    const set = ({ accountId: accountId, key: key, value: value })=>provider.set($f403f41047806be6$var$getKey({
            accountId: accountId,
            key: key
        }), value, $f403f41047806be6$var$getExpiryTime());
    const remove = ({ accountId: accountId, key: key })=>provider.remove($f403f41047806be6$var$getKey({
            accountId: accountId,
            key: key
        }));
    $f403f41047806be6$var$localStorage = {
        provider: provider,
        remove: remove,
        get: get,
        set: set
    };
    return $f403f41047806be6$var$localStorage;
};
const $f403f41047806be6$export$f2666fae743fa5f = (value)=>{
    $f403f41047806be6$export$aa821bfb3308a1f5().set({
        accountId: (0, $7dRgX.ACCOUNT_ID),
        key: (0, $7dRgX.KEY_HAS_NAVIGATED_FROM_LINK),
        value: value
    });
};

});

parcelRegister("jTgI9", function(module, exports) {

$parcel$export(module.exports, "isRoadmapRoute", () => $2e4ffaed7bae8e69$export$d1fa67c1ffb68871);

var $exb0h = parcelRequire("exb0h");
const $2e4ffaed7bae8e69$export$d1fa67c1ffb68871 = (routeName)=>{
    if (routeName === undefined) return false;
    return routeName === (0, $exb0h.ROUTE_NAMES).SOFTWARE_TIMELINE || routeName === (0, $exb0h.ROUTE_NAMES).SOFTWARE_TIMELINE_CLASSIC;
};

});

parcelRegister("6JZfU", function(module, exports) {

$parcel$export(module.exports, "getAdminHubUrl", () => $962b8ae814600457$export$631ba87ff5b9e288);

var $9dp5m = parcelRequire("9dp5m");
const $962b8ae814600457$export$631ba87ff5b9e288 = ({ suffix: suffix, cloudId: cloudId, orgId: orgId })=>{
    const instanceUrl = (0, $9dp5m.getATLContextUrl)('admin');
    if (orgId !== undefined && orgId !== '') return `${instanceUrl}/o/${orgId}/${suffix}`;
    if (cloudId) return `${instanceUrl}/s/${cloudId}/${suffix}`;
    return `${instanceUrl}/${suffix}`;
};

});

parcelRegister("iZV3I", function(module, exports) {

$parcel$export(module.exports, "getConnectActionLinkProps", () => $71c2f501f2f8e99c$export$8a467272e65de2b7);

var $jxzG5 = parcelRequire("jxzG5");

var $jMP2a = parcelRequire("jMP2a");
const $71c2f501f2f8e99c$export$8a467272e65de2b7 = (integrationKey, linkActionSubjectId, message)=>{
    // @ts-expect-error - TS2554 - Expected 3-4 arguments, but got 2.
    const link = (0, $jxzG5.getEmceeAppListingLink)(integrationKey, {
        source: 'quickstart',
        installDialogOpen: true
    });
    return {
        message: message,
        onClick: (event, analyticsEvent)=>{
            event.stopPropagation();
            const eventName = `${linkActionSubjectId}ConnectApp`;
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, eventName, {
                link: link,
                integration: integrationKey
            });
        },
        link: link
    };
};

});



parcelRegister("kL6gJ", function(module, exports) {

$parcel$export(module.exports, "getCrossProjectBoardTrait", () => $2a787116be621779$export$7f2186c37a3d095d);

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $lRmyA = parcelRequire("lRmyA");

var $jMP2a = parcelRequire("jMP2a");

var $7dRgX = parcelRequire("7dRgX");

var $lmEST = parcelRequire("lmEST");
const $2a787116be621779$var$CROSS_PROJECT_BOARD_TO_PLAN_UPSELL_TRAIT = 'segment_jsw_cross_project_board_trait_siteuser';
const $2a787116be621779$var$TAP_DELIVERY_PROXY_ENDPOINT = '/gateway/api/tap-delivery/api/v3/personalization';
const $2a787116be621779$var$ONE_DAY = 86400000;
const $2a787116be621779$export$88f2f25e1418caf1 = async (createAnalyticsEvent, siteId, userId)=>{
    try {
        const url = `${$2a787116be621779$var$TAP_DELIVERY_PROXY_ENDPOINT}/site/${siteId}/user/${userId}`;
        const result = await (0, $lRmyA.performGetRequest)(url);
        const analyticsEvent = createAnalyticsEvent({});
        (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'getJSWCrossProjectBoardTrait personalizationApi', {
            synthetic: (0, $1ybV0.ff)('jsw.pollinator.tenants')
        });
        return result;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'quickstartApiError',
                packageName: (0, $7dRgX.PACKAGE_NAME),
                teamName: (0, $7dRgX.PACKAGE_TEAM_NAME)
            },
            attributes: {
                error: error.message,
                endpointSource: 'getJSWCrossProjectBoardTrait',
                synthetic: (0, $1ybV0.ff)('jsw.pollinator.tenants')
            },
            sendToPrivacyUnsafeSplunk: true
        });
        return {
            attributes: []
        };
    }
};
const $2a787116be621779$export$7f2186c37a3d095d = async (createAnalyticsEvent, siteId, userId)=>{
    const { get: get, persist: persist } = (0, $lmEST.crossProjectBoardTraitSessionStorageProvider)();
    // Check session storage
    const sessionStorage = get();
    if (sessionStorage && userId === sessionStorage.userId && siteId === sessionStorage.siteId && Date.now() - sessionStorage.date < $2a787116be621779$var$ONE_DAY) {
        const analyticsEvent = createAnalyticsEvent({});
        (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'getJSWCrossProjectBoardTrait sessionStorage', {
            synthetic: (0, $1ybV0.ff)('jsw.pollinator.tenants')
        });
        return sessionStorage.attribute;
    }
    // Fetch from personalization
    const personalization = await $2a787116be621779$export$88f2f25e1418caf1(createAnalyticsEvent, siteId, userId);
    const attribute = personalization.attributes.find((att)=>att.name === $2a787116be621779$var$CROSS_PROJECT_BOARD_TO_PLAN_UPSELL_TRAIT);
    if (attribute !== undefined) persist({
        attribute: attribute,
        date: Date.now(),
        userId: userId,
        siteId: siteId
    });
    return attribute;
};

});
parcelRegister("lmEST", function(module, exports) {

$parcel$export(module.exports, "crossProjectBoardTraitSessionStorageProvider", () => $6d7ad5c5e3880914$export$99f3e48748c2a8c3);

var $89bO2 = parcelRequire("89bO2");

const $6d7ad5c5e3880914$var$crossProjectBoardTraitSessionProvider = (0, $89bO2.createSessionExpirableStorageProvider)((0, $e2fa640244aa9949$export$fac14ff24e5b1e7a));
const $6d7ad5c5e3880914$export$99f3e48748c2a8c3 = ()=>{
    const persist = (toPersist)=>{
        $6d7ad5c5e3880914$var$crossProjectBoardTraitSessionProvider.set((0, $e2fa640244aa9949$export$fac14ff24e5b1e7a), toPersist);
    };
    const get = ()=>$6d7ad5c5e3880914$var$crossProjectBoardTraitSessionProvider.get((0, $e2fa640244aa9949$export$fac14ff24e5b1e7a));
    return {
        get: get,
        persist: persist
    };
};

});
const $e2fa640244aa9949$export$fac14ff24e5b1e7a = 'jira-user-cross-project-board-trait';



parcelRegister("74z6M", function(module, exports) {

$parcel$export(module.exports, "getIsDevOpsProject", () => $22fff37650eaf366$export$88ee873472aa9bb7);

var $7dRgX = parcelRequire("7dRgX");
const $22fff37650eaf366$var$projectPropertyUrl = (projectKey)=>`/rest/api/2/project/${projectKey}/properties/${0, $7dRgX.KEY_IS_DEVOPS_PROJECT}`;
const $22fff37650eaf366$export$88ee873472aa9bb7 = async (projectKey)=>{
    const url = $22fff37650eaf366$var$projectPropertyUrl(projectKey);
    const response = await fetch(url);
    if (response.ok) {
        const result = await response.json();
        return result.value;
    }
    return false;
};

});

parcelRegister("9vuWT", function(module, exports) {

$parcel$export(module.exports, "getOnboardingSkipApplicationProperty", () => $c73311db2e118d57$export$980c26b6f100081d);

var $lRmyA = parcelRequire("lRmyA");
const $c73311db2e118d57$export$980c26b6f100081d = ()=>(0, $lRmyA.performGetRequest)('/rest/onboarding/1.0/skip');

});

parcelRegister("jssF8", function(module, exports) {

$parcel$export(module.exports, "nextSetChecklistIsDismissed", () => $ad333f190549603d$export$f24c05f83b880547);

var $79xbN = parcelRequire("79xbN");

var $7dRgX = parcelRequire("7dRgX");

var $8ppHd = parcelRequire("8ppHd");

var $5OjXh = parcelRequire("5OjXh");

var $ahbtR = parcelRequire("ahbtR");
const $ad333f190549603d$export$f24c05f83b880547 = (isDismissed)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        if ((0, $79xbN.expValEquals)('jsm_business_quickstart', 'cohort', 'experiment')) {
            const state = getState();
            const quickstartType = (0, $5OjXh.getQuickstartTypeSelector)(state);
            const currentIsDismissed = state.visibility[quickstartType] === (0, $7dRgX.QUICKSTART_UI_STATUS).DISMISSED;
            if (isDismissed === currentIsDismissed) // if state has not been updated we just return
            return;
            const quickstartStatus = isDismissed ? (0, $7dRgX.QUICKSTART_UI_STATUS).DISMISSED : (0, $7dRgX.QUICKSTART_UI_STATUS).OPEN;
            setState({
                visibility: {
                    ...state.visibility,
                    [quickstartType]: quickstartStatus
                },
                isFocusedOn: !isDismissed
            });
            (0, $8ppHd.pushToBackend)({
                key: (0, $7dRgX.getBackendVisibilityKey)(quickstartType),
                value: quickstartStatus
            });
            // Maintain backwards compatibility with Quickstart in case we need to turn the feature off
            // Delete code below when cleaning up
            if (isDismissed === false) // When setting IsDismissed to false, also setting QS status to OPEN so checklist appears in open state
            (0, $8ppHd.pushToBackend)({
                key: (0, $7dRgX.KEY_OPEN),
                value: true
            });
            else // When setting IsDismissed, also toggle the open state of the checklist to match.
            (0, $8ppHd.pushToBackend)({
                key: (0, $7dRgX.KEY_OPEN),
                value: false
            });
            (0, $8ppHd.pushToBackend)({
                key: (0, $7dRgX.KEY_DISMISSED),
                value: isDismissed
            });
            return;
        }
        /* Grab current state of is isDismissed */ const { isDismissed: currentIsDismissed } = getState();
        if (isDismissed === currentIsDismissed) // if state has not been updated we just return
        return;
        setState({
            isDismissed: isDismissed
        });
        if (isDismissed === false) // When setting IsDismissed to false, also setting QS status to OPEN so checklist appears in open state
        dispatch((0, $ahbtR.nextSetChecklistIsOpen)(true));
        else // When setting IsDismissed, also toggle the open state of the checklist to match.
        dispatch((0, $ahbtR.nextSetChecklistIsOpen)(false));
        (0, $8ppHd.pushToBackend)({
            key: (0, $7dRgX.KEY_DISMISSED),
            value: isDismissed
        });
    };

});
parcelRegister("ahbtR", function(module, exports) {

$parcel$export(module.exports, "nextSetChecklistIsOpen", () => $42c7858c3f713220$export$4249eabbb34e2e69);

var $79xbN = parcelRequire("79xbN");

var $7dRgX = parcelRequire("7dRgX");

var $8ppHd = parcelRequire("8ppHd");

var $5OjXh = parcelRequire("5OjXh");
const $42c7858c3f713220$export$4249eabbb34e2e69 = (isOpen)=>({ getState: getState, setState: setState })=>{
        if ((0, $79xbN.expValEquals)('jsm_business_quickstart', 'cohort', 'experiment')) {
            const state = getState();
            const quickstartType = (0, $5OjXh.getQuickstartTypeSelector)(state);
            const currentIsOpen = state.visibility[quickstartType] === (0, $7dRgX.QUICKSTART_UI_STATUS).OPEN;
            const currentIsMinimised = state.visibility[quickstartType] === (0, $7dRgX.QUICKSTART_UI_STATUS).MINIMIZED;
            if (currentIsOpen && isOpen || currentIsMinimised && !isOpen) // if state has not been updated we just return
            return;
            const quickstartStatus = isOpen ? (0, $7dRgX.QUICKSTART_UI_STATUS).OPEN : (0, $7dRgX.QUICKSTART_UI_STATUS).MINIMIZED;
            setState({
                visibility: {
                    ...state.visibility,
                    [quickstartType]: quickstartStatus
                },
                hasNudgeActive: false,
                isFocusedOn: isOpen
            });
            (0, $8ppHd.pushToBackend)({
                key: (0, $7dRgX.getBackendVisibilityKey)(quickstartType),
                value: quickstartStatus
            });
            // Maintain backwards compatibility with old global quickstart in case we need to turn the feature off
            // Delete code below when cleaning up
            (0, $8ppHd.pushToBackend)({
                key: (0, $7dRgX.KEY_OPEN),
                value: isOpen
            });
            return;
        }
        /* Grab current state of is isOpen */ const { isOpen: currentIsOpen } = getState();
        if (isOpen === currentIsOpen) // if state has not been updated we just return
        return;
        setState({
            isOpen: isOpen,
            hasNudgeActive: false,
            isFocusedOn: isOpen
        });
        (0, $8ppHd.pushToBackend)({
            key: (0, $7dRgX.KEY_OPEN),
            value: isOpen
        });
    };

});


parcelRegister("g1Zgk", function(module, exports) {

$parcel$export(module.exports, "nextMarkAsCompletedTask", () => $13a2c09b85cecff0$export$d6628d41a3bec42d);

var $8ppHd = parcelRequire("8ppHd");
const $13a2c09b85cecff0$export$d6628d41a3bec42d = (taskId)=>({ getState: getState, setState: setState })=>{
        // When a task is complete:
        // Check to see if the task is complete in the completedKeys already
        // update the checklist dict (maybe should be at a different point or use setState)
        const { completedTaskList: completedTaskList } = getState();
        if (completedTaskList.includes(taskId)) return;
        // update the backend with the KEY and true
        (0, $8ppHd.pushToBackend)({
            key: taskId,
            value: true
        });
        // update itemsList to reflect checked status. clone -> update -> override
        setState({
            completedTaskList: [
                ...completedTaskList,
                taskId
            ]
        });
    };

});

parcelRegister("fzDyP", function(module, exports) {

$parcel$export(module.exports, "mapPersonaTraitsToExperience", () => $b7c30df71a7183dd$export$54560e73c5a0e8ff);

var $4vWp2 = parcelRequire("4vWp2");
const $b7c30df71a7183dd$export$54560e73c5a0e8ff = (userTraitsPersona)=>{
    switch(userTraitsPersona?.value){
        case (0, $4vWp2.PERSONA_TYPE).MARKETING_GENERIC:
        case (0, $4vWp2.PERSONA_TYPE).CAMPAIGN_MARKETING_LEAD:
            return (0, $4vWp2.EXPERIENCE_TYPE).MARKETER_LEAD;
        case (0, $4vWp2.PERSONA_TYPE).PROJECT_MARKETING_LEAD:
            return (0, $4vWp2.EXPERIENCE_TYPE).MARKETER_PROJECT;
        case (0, $4vWp2.PERSONA_TYPE).CONTENT_MARKETING_LEAD:
            return (0, $4vWp2.EXPERIENCE_TYPE).MARKETER_CONTENT;
        case (0, $4vWp2.PERSONA_TYPE).PMM:
            return (0, $4vWp2.EXPERIENCE_TYPE).MARKETER_PMM;
        default:
            return undefined;
    }
};

});


parcelRegister("aI5eR", function(module, exports) {

$parcel$export(module.exports, "setNudgeStep", () => $970ae6c28ea9ba56$export$4debc323813b6997);
const $970ae6c28ea9ba56$export$4debc323813b6997 = (nudge)=>({ getState: getState, setState: setState })=>{
        const { nudgeStep: nudgeStep } = getState();
        if (nudge === nudgeStep) return;
        setState({
            nudgeStep: nudge
        });
    };
var $970ae6c28ea9ba56$export$2e2bcd8739ae039 = $970ae6c28ea9ba56$export$4debc323813b6997;

});

parcelRegister("1jaP6", function(module, exports) {

$parcel$export(module.exports, "addMountedNudge", () => $d76ba5c46e283800$export$92a89c32d0ea3943);
$parcel$export(module.exports, "removeMountedNudge", () => $d76ba5c46e283800$export$748f4cda8ab98c91);
const $d76ba5c46e283800$export$92a89c32d0ea3943 = (nudge)=>({ getState: getState, setState: setState })=>{
        const { mountedNudges: mountedNudges } = getState();
        // skip store update if this nudge is already added
        if (mountedNudges.includes(nudge)) return;
        setState({
            mountedNudges: [
                ...mountedNudges,
                nudge
            ]
        });
    };
const $d76ba5c46e283800$export$748f4cda8ab98c91 = (nudge)=>({ getState: getState, setState: setState })=>{
        const { mountedNudges: mountedNudges } = getState();
        // skip store update if this nudge is already removed
        if (!mountedNudges.includes(nudge)) return;
        setState({
            mountedNudges: mountedNudges.filter((mountedNudge)=>mountedNudge !== nudge)
        });
    };

});

parcelRegister("lCKeP", function(module, exports) {

$parcel$export(module.exports, "setShouldRenderComponent", () => $3e69fb4a25487c6b$export$1f9c6770ed938b6e);
const $3e69fb4a25487c6b$export$1f9c6770ed938b6e = (shouldRenderComponent)=>({ getState: getState, setState: setState })=>{
        /* Grab current state of is shouldRenderComponent */ const { shouldRenderComponent: currentShouldRenderComponent } = getState();
        if (shouldRenderComponent === currentShouldRenderComponent) // if state has not been updated we just return
        return;
        setState({
            shouldRenderComponent: shouldRenderComponent
        });
    };
var $3e69fb4a25487c6b$export$2e2bcd8739ae039 = $3e69fb4a25487c6b$export$1f9c6770ed938b6e;

});

parcelRegister("9FTSc", function(module, exports) {

$parcel$export(module.exports, "setProjectState", () => $e8f28a5d91b40a98$export$1ba498e440c0a1e4);
const $e8f28a5d91b40a98$export$1ba498e440c0a1e4 = (projectState)=>({ setState: setState })=>{
        setState({
            projectState: projectState
        });
    };
var $e8f28a5d91b40a98$export$2e2bcd8739ae039 = $e8f28a5d91b40a98$export$1ba498e440c0a1e4;

});

parcelRegister("iq74h", function(module, exports) {

$parcel$export(module.exports, "setHasNudgeActive", () => $d5d9f3bbfe59a243$export$497c281e6eb0786e);
const $d5d9f3bbfe59a243$export$497c281e6eb0786e = (hasNudgeActive, itemName = '')=>({ getState: getState, setState: setState })=>{
        /* Grab current state of is currentHasNudgeActive */ const { hasNudgeActive: currentHasNudgeActive, openTask: openTask } = getState();
        if (hasNudgeActive === currentHasNudgeActive) // if state has not been updated we just return
        return;
        if (hasNudgeActive === false && itemName !== openTask) // do not update a nudge if the current open task is different than the one we called the function with
        return;
        setState({
            hasNudgeActive: hasNudgeActive
        });
    };
var $d5d9f3bbfe59a243$export$2e2bcd8739ae039 = $d5d9f3bbfe59a243$export$497c281e6eb0786e;

});

parcelRegister("cKB0H", function(module, exports) {

$parcel$export(module.exports, "forceHideNudge", () => $395e6590b72e7adc$export$6d1ed97b83a62e8e);
// We use this action in cases where we want to hide the nudge no matter what.
const $395e6590b72e7adc$export$6d1ed97b83a62e8e = ()=>({ setState: setState })=>{
        setState({
            hasNudgeActive: false
        });
    };

});

parcelRegister("8n1zQ", function(module, exports) {

$parcel$export(module.exports, "setHasEverSeenRoute", () => $9526def4b4979224$export$28e0a4314a1ce52f);

var $7dRgX = parcelRequire("7dRgX");

var $8ppHd = parcelRequire("8ppHd");
const $9526def4b4979224$export$28e0a4314a1ce52f = (update)=>({ getState: getState, setState: setState })=>{
        const { hasEverSeenRoute: currentHasEverSeenRoute } = getState();
        const somethingHasBeenUpdated = Object.keys(update).some(// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<"jsw.onboarding.experiment.personalised.onboarding.ntkw.onboarding.it2.roadmap", boolean>>'.
        (key)=>update[key] !== currentHasEverSeenRoute[key]);
        if (!somethingHasBeenUpdated) return;
        const newHasEverSeenRoute = {
            ...currentHasEverSeenRoute,
            ...update
        };
        setState({
            hasEverSeenRoute: newHasEverSeenRoute
        });
        (0, $8ppHd.pushToBackend)({
            key: (0, $7dRgX.KEY_HAS_EVER_SEEN_ROUTE),
            value: newHasEverSeenRoute
        });
    };
var $9526def4b4979224$export$2e2bcd8739ae039 = $9526def4b4979224$export$28e0a4314a1ce52f;

});

parcelRegister("ioWKV", function(module, exports) {

$parcel$export(module.exports, "setRoadmapIsCreateEnabled", () => $3aa7d72125406d8f$export$35ea35d1a8e07307);
$parcel$export(module.exports, "setRoadmapIsListEmpty", () => $3aa7d72125406d8f$export$932967764e7a0b31);
const $3aa7d72125406d8f$export$35ea35d1a8e07307 = (roadmapIsCreateEnabled)=>({ getState: getState, setState: setState })=>{
        const { roadmapIsCreateEnabled: currentRoadmapIsCreateEnabled } = getState();
        // skip store update if no state change
        if (currentRoadmapIsCreateEnabled === roadmapIsCreateEnabled) return;
        setState({
            roadmapIsCreateEnabled: roadmapIsCreateEnabled
        });
    };
const $3aa7d72125406d8f$export$932967764e7a0b31 = (roadmapIsListEmpty)=>({ getState: getState, setState: setState })=>{
        const { roadmapIsListEmpty: currentRoadmapIsListEmpty } = getState();
        // skip store update if no state change
        if (currentRoadmapIsListEmpty === roadmapIsListEmpty) return;
        setState({
            roadmapIsListEmpty: roadmapIsListEmpty
        });
    };

});

parcelRegister("P9NN5", function(module, exports) {

$parcel$export(module.exports, "openNextTask", () => $cc1aff9593d14250$export$867dbb6d61569ae9);

var $egHFE = parcelRequire("egHFE");

var $gn07r = parcelRequire("gn07r");
const $cc1aff9593d14250$export$867dbb6d61569ae9 = ()=>({ getState: getState, dispatch: dispatch })=>{
        const { openTask: openTask, tasks: tasks } = getState();
        if (!tasks) return;
        const { items: items } = tasks;
        const taskIdToExpand = (0, $egHFE.getNextTask)(items, openTask);
        if (taskIdToExpand === null) return;
        dispatch((0, $gn07r.nextOpenTask)(taskIdToExpand));
    };

});
parcelRegister("egHFE", function(module, exports) {

$parcel$export(module.exports, "getNextNonCompleteTask", () => $e5132247b337604d$export$b61dc70e2ed3fae3);
$parcel$export(module.exports, "getNextTask", () => $e5132247b337604d$export$404421ce8f3cbf9a);

var $bnszi = parcelRequire("bnszi");
const $e5132247b337604d$export$b61dc70e2ed3fae3 = (tasks, completed, openTask)=>{
    const taskPosition = (0, $bnszi.getTaskIndex)(tasks, openTask);
    // if the task does not exist(-1), we want to start at 0
    // if it exists we want to start at array index + 1 (taskPosition is already index+1)
    const start = taskPosition === -1 ? 0 : taskPosition;
    const len = tasks.length;
    // This loop:
    // 1) searches for non completed items from the start index to last index of the array
    // 2) searches from 0 until start if nothing was found during 1)
    for(let i = start; i < start + len; i += 1){
        const ind = i % len;
        if (!completed.includes(tasks[ind])) return tasks[ind];
    }
    // nothing was found there is no task to open
    return null;
};
const $e5132247b337604d$export$404421ce8f3cbf9a = (tasks, openTask)=>{
    const taskPosition = (0, $bnszi.getTaskIndex)(tasks, openTask);
    // if the task does not exist(-1), we want to start at 0
    // if it exists we want to start at array index + 1 (taskPosition is already index+1)
    const ind = taskPosition === -1 ? 0 : taskPosition;
    return tasks[ind] ? tasks[ind] : null;
};

});

parcelRegister("gn07r", function(module, exports) {

$parcel$export(module.exports, "nextOpenTask", () => $4f8f6eacc80982cf$export$5deb889489d2f989);
$parcel$export(module.exports, "nextAutoOpenTask", () => $4f8f6eacc80982cf$export$cc5f3544a6cb2922);

var $79xbN = parcelRequire("79xbN");

var $eI5EY = parcelRequire("eI5EY");


var $7dRgX = parcelRequire("7dRgX");

var $8ppHd = parcelRequire("8ppHd");

var $aI5eR = parcelRequire("aI5eR");

var $iq74h = parcelRequire("iq74h");
const $4f8f6eacc80982cf$var$openTask = (taskId)=>({ setState: setState })=>{
        setState({
            openTask: taskId
        });
        (0, $8ppHd.pushToBackend)({
            key: (0, $7dRgX.KEY_OPEN_TASK),
            value: taskId
        });
    };
const $4f8f6eacc80982cf$export$5deb889489d2f989 = (taskId, { closeNudge: closeNudge } = {})=>({ dispatch: dispatch, getState: getState })=>{
        dispatch($4f8f6eacc80982cf$var$openTask(taskId));
        const { completedTaskList: completedTaskList } = getState();
        // eslint-disable-next-line jira/ff/unsafe-no-exposure
        const [simplifyKanbanQsExpConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_simplify_kanban_qs');
        // eslint-disable-next-line jira/ff/unsafe-no-exposure
        const [disableAutoNudgeTour] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_disable_auto_nudge_tours');
        // eslint-disable-next-line jira/ff/unsafe-no-exposure
        const [simplifyKanbanQsForAllExpConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_simplify_kanban_qs_all_users');
        const shouldSimplifyKanbanQs = simplifyKanbanQsForAllExpConfig.get('isEnabled', false) || disableAutoNudgeTour.get('isDisabled', false) && simplifyKanbanQsExpConfig.get('cohort', 'not-enrolled') === 'variation';
        const taskIsCompleted = completedTaskList.includes(taskId);
        const taskIdExistsAndIsNotCompleted = !(taskId === '' || taskId === null) && !taskIsCompleted;
        if (closeNudge && (0, $eI5EY.fg)('kuro-4953-quickstart-improvements-and-fixes')) dispatch((0, $iq74h.setHasNudgeActive)(false, taskId));
        else dispatch((0, $iq74h.setHasNudgeActive)(taskIdExistsAndIsNotCompleted, taskId));
        // This is a temporary solution for Scrum Onboarding.
        // See https://hello.atlassian.net/wiki/spaces/agile/pages/1321008806/Draft+Quickstart+Nudge+Interaction for details
        if (taskIdExistsAndIsNotCompleted && taskId === (0, $7dRgX.SCRUM_ONBOARDING_TASK)) dispatch((0, $aI5eR.setNudgeStep)((0, $8379f5d78bf6fb5a$export$b1a6ab17737f33e)));
        else if (taskIdExistsAndIsNotCompleted && taskId === (0, $7dRgX.KANBAN_ONBOARDING_TASK)) dispatch((0, $aI5eR.setNudgeStep)((0, $8379f5d78bf6fb5a$export$3366ddefe77d5112)));
        else if (shouldSimplifyKanbanQs && taskIdExistsAndIsNotCompleted && taskId === (0, $7dRgX.ADD_COLUMNS_TASK)) dispatch((0, $aI5eR.setNudgeStep)((0, $8379f5d78bf6fb5a$export$3366ddefe77d5112)));
        else dispatch((0, $aI5eR.setNudgeStep)(''));
    };
const $4f8f6eacc80982cf$export$cc5f3544a6cb2922 = (taskId)=>({ dispatch: dispatch })=>{
        dispatch($4f8f6eacc80982cf$var$openTask(taskId));
        dispatch((0, $iq74h.setHasNudgeActive)(false, taskId));
        dispatch((0, $aI5eR.setNudgeStep)(''));
    };

});


parcelRegister("6GDwI", function(module, exports) {

$parcel$export(module.exports, "resetIsQuickstartLoaded", () => $cf59d5b51193e99b$export$bda085a823763e5a);

var $7dRgX = parcelRequire("7dRgX");

var $5OjXh = parcelRequire("5OjXh");
const $cf59d5b51193e99b$export$bda085a823763e5a = ()=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $5OjXh.getQuickstartTypeSelector)(state);
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: (0, $7dRgX.QUICKSTART_UI_STATUS).NOT_LOADED
            },
            hasNudgeActive: false,
            isQuickstartLoaded: false
        });
    };

});

parcelRegister("dn2YB", function(module, exports) {

$parcel$export(module.exports, "nextSetChecklistItemSeen", () => $ae4dc9d92cd110b5$export$4eac017dcde0be8f);

var $79xbN = parcelRequire("79xbN");

var $7dRgX = parcelRequire("7dRgX");

var $8ppHd = parcelRequire("8ppHd");

var $gn07r = parcelRequire("gn07r");
const $ae4dc9d92cd110b5$export$4eac017dcde0be8f = (taskId)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        const hasSeenTaskId = (0, $7dRgX.convertToHaveSeenItTask)(taskId);
        const { hasSeenTasks: hasSeenTasks } = getState();
        if (hasSeenTasks.includes(hasSeenTaskId)) return;
        setState({
            hasSeenTasks: [
                ...hasSeenTasks,
                hasSeenTaskId
            ]
        });
        (0, $8ppHd.pushToBackend)({
            key: (0, $7dRgX.convertToHaveSeenItTask)(taskId),
            value: true
        });
        // This will prioritise expanding this current taskId as the next card to expand.
        // For simplify kanban QS we don't want to expand hasSeen cards first
        // eslint-disable-next-line jira/ff/unsafe-no-exposure
        const [simplifyKanbanQsExpConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_simplify_kanban_qs');
        // eslint-disable-next-line jira/ff/unsafe-no-exposure
        const [disableAutoNudgeTour] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_disable_auto_nudge_tours');
        // eslint-disable-next-line jira/ff/unsafe-no-exposure
        const [simplifyKanbanQsForAllExpConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_simplify_kanban_qs_all_users');
        const shouldSimplifyKanbanQs = simplifyKanbanQsForAllExpConfig.get('isEnabled', false) || disableAutoNudgeTour.get('isDisabled', false) && simplifyKanbanQsExpConfig.get('cohort', 'not-enrolled') === 'variation';
        if (shouldSimplifyKanbanQs === false) dispatch((0, $gn07r.nextOpenTask)(taskId));
    };

});

parcelRegister("7I9OF", function(module, exports) {

$parcel$export(module.exports, "nextAutoExpand", () => $8c8cecc90fef13d0$export$3d24e97d30cfd09e);

var $7dRgX = parcelRequire("7dRgX");

var $cY793 = parcelRequire("cY793");

var $egHFE = parcelRequire("egHFE");

var $gn07r = parcelRequire("gn07r");
const $8c8cecc90fef13d0$export$3d24e97d30cfd09e = ()=>({ getState: getState, dispatch: dispatch })=>{
        const hasNudgeToShowAfterNavigation = (0, $cY793.localStorageProvider)().get({
            accountId: (0, $7dRgX.ACCOUNT_ID),
            key: (0, $7dRgX.KEY_HAS_NAVIGATED_FROM_LINK)
        });
        if (hasNudgeToShowAfterNavigation) return;
        const { openTask: openTask, completedTaskList: completedTaskList, tasks: tasks } = getState();
        if (!tasks) return;
        const { items: items } = tasks;
        if (// @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
        items.includes(openTask) && // @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
        !completedTaskList.includes(openTask)) return;
        const taskIdToExpand = (0, $egHFE.getNextNonCompleteTask)(items, completedTaskList, openTask);
        if (taskIdToExpand === null) return;
        dispatch((0, $gn07r.nextAutoOpenTask)(taskIdToExpand));
    };

});

parcelRegister("cDYe7", function(module, exports) {

$parcel$export(module.exports, "nextShouldShowNudgeAfterNavigation", () => $3949917718560fd8$export$6f336ccb6432fcd0);
// Special case for nudges that need to show after a navigation.

var $7dRgX = parcelRequire("7dRgX");

var $cY793 = parcelRequire("cY793");

var $iq74h = parcelRequire("iq74h");
const $3949917718560fd8$export$6f336ccb6432fcd0 = (taskId)=>({ dispatch: dispatch })=>{
        const nudgeToShowAfterNavigationKeyPair = {
            accountId: (0, $7dRgX.ACCOUNT_ID),
            key: (0, $7dRgX.KEY_HAS_NAVIGATED_FROM_LINK)
        };
        const shouldShowNudge = (0, $cY793.localStorageProvider)().get(nudgeToShowAfterNavigationKeyPair) === taskId;
        if (shouldShowNudge) {
            dispatch((0, $iq74h.setHasNudgeActive)(true));
            (0, $cY793.localStorageProvider)().remove(nudgeToShowAfterNavigationKeyPair);
        }
    };

});

parcelRegister("kDmv4", function(module, exports) {

$parcel$export(module.exports, "nextGetTasks", () => $2cffb9be55c6d345$export$15d877e1f3abf489);

var $a0vMn = parcelRequire("a0vMn");
const $2cffb9be55c6d345$export$15d877e1f3abf489 = (props)=>({ setState: setState })=>{
        const tasks = (0, $a0vMn.getAllTasks)(props);
        setState({
            tasks: tasks
        });
    };

});
parcelRegister("a0vMn", function(module, exports) {

$parcel$export(module.exports, "getAllTasks", () => $62ef3d093ab58a52$export$d1f442602a91e7cc);

var $4K830 = parcelRequire("4K830");

var $exb0h = parcelRequire("exb0h");

var $79xbN = parcelRequire("79xbN");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");


var $6WXNs = parcelRequire("6WXNs");

var $7dRgX = parcelRequire("7dRgX");

var $jTgI9 = parcelRequire("jTgI9");

var $hFK9U = parcelRequire("hFK9U");

var $fricC = parcelRequire("fricC");

var $4vWp2 = parcelRequire("4vWp2");

var $kxycg = parcelRequire("kxycg");
var $3sCLn = parcelRequire("3sCLn");
var $2UWYK = parcelRequire("2UWYK");
var $c2fmF = parcelRequire("c2fmF");

var $2hhuw = parcelRequire("2hhuw");

var $5f5jN = parcelRequire("5f5jN");
const $62ef3d093ab58a52$var$getTaskListItem = ({ variants: variants, taskVariants: taskVariants, taskList: taskList, taskGroupParent: taskGroupParent })=>{
    if (variants.includes((0, $2UWYK.JSW).experiment.jswReverseTrial)) {
        const { title: title, items: items } = taskList[taskGroupParent === (0, $7dRgX.ROOT_TASK) ? (0, $7dRgX.REVERSE_TRIAL_ROOT_TASK) : taskGroupParent] ?? taskList[0, $7dRgX.REVERSE_TRIAL_ROOT_TASK];
        return {
            title: title,
            items: (0, $2hhuw.getTasks)(variants, taskVariants, items)
        };
    }
    const { title: title, items: items } = taskList[taskGroupParent] ?? taskList[0, $7dRgX.ROOT_TASK];
    return {
        title: title,
        items: (0, $2hhuw.getTasks)(variants, taskVariants, items)
    };
};
const $62ef3d093ab58a52$var$createJswTasks = (projectState, taskGroupParent, routeName, shouldShowScrumOnboardingExperience, mountedNudges, canCreateProject, isEligibleToUpdateSitename, isCustomerTemplateProject, isCrossProjectBoardToPlanUpsell, canEditPlans, premiumTrialOnSignup)=>{
    const variants = new Set();
    const isTmpScrumWithSprintPermission = mountedNudges.includes((0, $7dRgX.BACKLOG_CREATE_SPRINT_NUDGE_ID));
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [simplifyKanbanQsExpConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_simplify_kanban_qs');
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [disableAutoNudgeTour] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_disable_auto_nudge_tours');
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [simplifyKanbanQsForAllExpConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_simplify_kanban_qs_all_users');
    const shouldSimplifyKanbanQs = simplifyKanbanQsForAllExpConfig.get('isEnabled', false) || disableAutoNudgeTour.get('isDisabled', false) && simplifyKanbanQsExpConfig.get('cohort', 'not-enrolled') === 'variation';
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [simplifyJSWQsExpConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_simplify_qs_m3');
    const isEligibleForKanbanTour = mountedNudges.includes((0, $8379f5d78bf6fb5a$export$3366ddefe77d5112));
    if ((0, $1ybV0.ff)('jsw.onboarding.rollout.kuro-5740') && (0, $4K830.isFedRamp)()) variants.add((0, $2UWYK.JSW).experience.fedRamp);
    if (premiumTrialOnSignup && (0, $eI5EY.fg)('jsw_reverse_trials_feature_gate')) variants.add((0, $2UWYK.JSW).experiment.jswReverseTrial);
    if (simplifyJSWQsExpConfig.get('isEnabled', false)) variants.add((0, $2UWYK.JSW).experiment.simplifyTmpQS);
    if ((0, $1ybV0.ff)('jsw.onboarding.rollout.kuro-2250') && isCustomerTemplateProject) variants.add((0, $2UWYK.JSW).projectProperties.isCreatedFromCustomerTemplate);
    if (shouldShowScrumOnboardingExperience && isTmpScrumWithSprintPermission) variants.add((0, $2UWYK.JSW).experiment.scrumOnboarding);
    if (isCrossProjectBoardToPlanUpsell) variants.add((0, $2UWYK.JSW).trait.crossProjectBoardToPlanUpsell);
    if (canEditPlans) variants.add((0, $2UWYK.JSW).permissions.hasPlanEditPermissions);
    if (isEligibleForKanbanTour || routeName !== (0, $exb0h.ROUTE_NAMES).SOFTWARE_BOARDS) variants.add((0, $2UWYK.JSW).experience.kanbanOnboarding);
    if (shouldSimplifyKanbanQs) variants.add((0, $2UWYK.JSW).experiment.simplifyKanbanQS);
    if (canCreateProject === false) variants.add((0, $2UWYK.JSW).permissions.notCanCreateProject);
    if (projectState?.isNextGen) variants.add((0, $2UWYK.JSW).projectStyle.teamManaged);
    else variants.add((0, $2UWYK.JSW).projectStyle.companyManaged);
    if (projectState?.isProjectAdmin) variants.add((0, $2UWYK.JSW).userRole.projectAdmin);
    if (projectState?.userRole === (0, $fricC.USER_ROLE).JIRA_ADMIN) {
        variants.add((0, $2UWYK.JSW).userRole.jiraAdmin);
        variants.add((0, $2UWYK.JSW).userRole.admin);
    }
    if (projectState?.userRole === (0, $fricC.USER_ROLE).SITE_ADMIN) {
        variants.add((0, $2UWYK.JSW).userRole.siteAdmin);
        variants.add((0, $2UWYK.JSW).userRole.admin);
    }
    if (projectState?.edition === (0, $6WXNs.FREE_EDITION)) variants.add((0, $2UWYK.JSW).edition.free);
    else if (projectState?.edition === (0, $6WXNs.STANDARD_EDITION)) variants.add((0, $2UWYK.JSW).edition.standard);
    else if (projectState?.edition === (0, $6WXNs.PREMIUM_EDITION)) variants.add((0, $2UWYK.JSW).edition.premium);
    if ((0, $jTgI9.isRoadmapRoute)(routeName)) variants.add((0, $2UWYK.JSW).route.softwareRoadmap);
    else if (routeName === (0, $exb0h.ROUTE_NAMES).SOFTWARE_BACKLOG) variants.add((0, $2UWYK.JSW).route.softwareBacklog);
    else if (routeName === (0, $exb0h.ROUTE_NAMES).SOFTWARE_BOARDS) variants.add((0, $2UWYK.JSW).route.softwareBoard);
    else if (routeName === (0, $exb0h.ROUTE_NAMES).SOFTWARE_LIST || routeName === (0, $exb0h.ROUTE_NAMES).SOFTWARE_LIST_CLASSIC) variants.add((0, $2UWYK.JSW).route.softwareList);
    else if (routeName === (0, $exb0h.ROUTE_NAMES).PROJECT_SETTINGS_SOFTWARE_ACCESS) variants.add((0, $2UWYK.JSW).route.projectSettingsSoftwareAccess);
    else if (routeName === (0, $exb0h.ROUTE_NAMES).ISSUE) variants.add((0, $2UWYK.JSW).route.issue);
    else if ((0, $1ybV0.ff)('jsw-calendar-view-onboarding_q3bvy') && (routeName === (0, $exb0h.ROUTE_NAMES).SOFTWARE_CALENDAR || routeName === (0, $exb0h.ROUTE_NAMES).SOFTWARE_CALENDAR_CLASSIC)) variants.add((0, $2UWYK.JSW).route.softwareCalendar);
    if (isEligibleToUpdateSitename) variants.add((0, $2UWYK.JSW).experiment.customizeSiteName);
    return $62ef3d093ab58a52$var$getTaskListItem({
        variants: Array.from(variants.values()),
        taskVariants: (0, $2UWYK.JSW).taskVariants,
        taskList: (0, $2UWYK.JSW).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $62ef3d093ab58a52$var$createJwmTasks = (projectState, taskGroupParent, personaExperience)=>{
    const variants = [];
    variants.push((0, $c2fmF.JWM).experiments.projectTheming);
    if (projectState?.isProjectAdmin) variants.push((0, $c2fmF.JWM).userRole.projectAdmin);
    if (projectState?.userRole === (0, $fricC.USER_ROLE).JIRA_ADMIN) variants.push((0, $c2fmF.JWM).userRole.jiraAdmin);
    if (projectState?.userRole === (0, $fricC.USER_ROLE).SITE_ADMIN) variants.push((0, $c2fmF.JWM).userRole.siteAdmin);
    if (projectState?.isSampleProject) variants.push((0, $c2fmF.JWM).experiments.isSampleProject);
    else variants.push((0, $c2fmF.JWM).experiments.isNotSampleProject);
    if (projectState?.isTrelloCrossflow) variants.push((0, $c2fmF.JWM).experiments.trelloCrossflow);
    if ((0, $hFK9U.isTailoredQuickstartEnabled)(personaExperience)) {
        variants.push((0, $c2fmF.JWM).experiments.personalizedExperience);
        switch(personaExperience){
            case (0, $4vWp2.EXPERIENCE_TYPE).MARKETER_LEAD:
                variants.push((0, $c2fmF.JWM).personalizedExperienceExperiments.marketingLeader);
                break;
            case (0, $4vWp2.EXPERIENCE_TYPE).MARKETER_PROJECT:
                variants.push((0, $c2fmF.JWM).personalizedExperienceExperiments.projectMarketer);
                break;
            case (0, $4vWp2.EXPERIENCE_TYPE).MARKETER_CONTENT:
                variants.push((0, $c2fmF.JWM).personalizedExperienceExperiments.contentMarketer);
                break;
            case (0, $4vWp2.EXPERIENCE_TYPE).MARKETER_PMM:
                variants.push((0, $c2fmF.JWM).personalizedExperienceExperiments.productMarketingManager);
                break;
            default:
                break;
        }
    }
    return $62ef3d093ab58a52$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $c2fmF.JWM).taskVariants,
        taskList: (0, $c2fmF.JWM).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $62ef3d093ab58a52$var$createJsmTasks = (projectState, taskGroupParent)=>{
    const variants = [];
    variants.push((0, $3sCLn.JSM).experiments.projectTheming);
    if (projectState?.isProjectAdmin) variants.push((0, $3sCLn.JSM).userRole.projectAdmin);
    if (projectState?.userRole === (0, $fricC.USER_ROLE).JIRA_ADMIN) variants.push((0, $3sCLn.JSM).userRole.jiraAdmin);
    if (projectState?.userRole === (0, $fricC.USER_ROLE).SITE_ADMIN) variants.push((0, $3sCLn.JSM).userRole.siteAdmin);
    return $62ef3d093ab58a52$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $3sCLn.JSM).taskVariants,
        taskList: (0, $3sCLn.JSM).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $62ef3d093ab58a52$var$createDevopsTasks = (taskGroupParent)=>{
    const variants = [];
    return $62ef3d093ab58a52$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $kxycg.DEVOPS).taskVariants,
        taskList: (0, $kxycg.DEVOPS).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $62ef3d093ab58a52$export$d1f442602a91e7cc = ({ projectState: projectState, isDevOpsProject: isDevOpsProject, taskGroupParent: taskGroupParent, routeName: routeName, shouldShowScrumOnboardingExperience: shouldShowScrumOnboardingExperience, mountedNudges: mountedNudges, canCreateProject: canCreateProject, isEligibleToUpdateSitename: isEligibleToUpdateSitename, isCustomerTemplateProject: isCustomerTemplateProject, isCrossProjectBoardToPlanUpsell: isCrossProjectBoardToPlanUpsell, canEditPlans: canEditPlans, premiumTrialOnSignup: premiumTrialOnSignup, personaExperience: personaExperience })=>{
    if ((0, $5f5jN.isJwmProject)(projectState)) return $62ef3d093ab58a52$var$createJwmTasks(projectState, taskGroupParent, personaExperience);
    if ((0, $5f5jN.isJsmProject)(projectState)) return $62ef3d093ab58a52$var$createJsmTasks(projectState, taskGroupParent);
    if (isDevOpsProject) return $62ef3d093ab58a52$var$createDevopsTasks(taskGroupParent);
    return $62ef3d093ab58a52$var$createJswTasks(projectState, taskGroupParent, routeName, shouldShowScrumOnboardingExperience, mountedNudges, canCreateProject, isEligibleToUpdateSitename, isCustomerTemplateProject, isCrossProjectBoardToPlanUpsell, canEditPlans, premiumTrialOnSignup);
};

});
parcelRegister("fricC", function(module, exports) {

$parcel$export(module.exports, "USER_ROLE", () => $3def7289adf5e608$export$8eeb199b23203523);
const $3def7289adf5e608$export$8eeb199b23203523 = {
    END_USER: 'end-user',
    SITE_ADMIN: 'site-admin',
    JIRA_ADMIN: 'jira-admin'
};

});

parcelRegister("kxycg", function(module, exports) {

$parcel$export(module.exports, "DEVOPS", () => $503385b7e39437c3$export$bb75b6064c92010c);

var $bxltp = parcelRequire("bxltp");
const $503385b7e39437c3$export$bb75b6064c92010c = {
    taskList: (0, $bxltp.TASK_LIST),
    taskVariants: (0, $bxltp.TASK_VARIANTS),
    experiment: (0, $bxltp.Experiment)
};

});
parcelRegister("bxltp", function(module, exports) {

$parcel$export(module.exports, "Experiment", () => $7cc3b723e4b7a76f$export$4e0ab25c8a7e4009);
$parcel$export(module.exports, "TASK_LIST", () => $7cc3b723e4b7a76f$export$601c8c0f45aeb0a0);
$parcel$export(module.exports, "TASK_VARIANTS", () => $7cc3b723e4b7a76f$export$36f4d47dfe11b613);

var $7dRgX = parcelRequire("7dRgX");

var $ePWG3 = parcelRequire("ePWG3");
const $7cc3b723e4b7a76f$export$4e0ab25c8a7e4009 = {};
const $7cc3b723e4b7a76f$export$601c8c0f45aeb0a0 = Object.freeze({
    root: {
        title: (0, $ePWG3.messages).rootTitle,
        items: [
            (0, $7dRgX.DEVOPS_WELCOME_TO_YOUR_PROJECT_TASK),
            (0, $7dRgX.DEVOPS_GET_TO_KNOW_JIRA_TASK),
            (0, $7dRgX.DEVOPS_NAVIGATE_YOUR_TOOLS_TASK),
            (0, $7dRgX.DEVOPS_CAPTURE_INTEGRATIONS_TASK),
            (0, $7dRgX.DEVOPS_CREATE_AUTOMATION_RULES_TASK),
            (0, $7dRgX.DEVOPS_INVITE_TEAMMATES_TASK),
            (0, $7dRgX.DEVOPS_FIND_HELP_TASK)
        ]
    }
});
const $7cc3b723e4b7a76f$export$36f4d47dfe11b613 = {
    [(0, $7dRgX.DEVOPS_WELCOME_TO_YOUR_PROJECT_TASK)]: {
        position: {
            default: 0
        },
        visibility: {
            default: true
        }
    },
    [(0, $7dRgX.DEVOPS_GET_TO_KNOW_JIRA_TASK)]: {
        position: {
            default: 100
        },
        visibility: {
            default: true
        }
    },
    [(0, $7dRgX.DEVOPS_NAVIGATE_YOUR_TOOLS_TASK)]: {
        position: {
            default: 200
        },
        visibility: {
            default: true
        }
    },
    [(0, $7dRgX.DEVOPS_CAPTURE_INTEGRATIONS_TASK)]: {
        position: {
            default: 300
        },
        visibility: {
            default: true
        }
    },
    [(0, $7dRgX.DEVOPS_CREATE_AUTOMATION_RULES_TASK)]: {
        position: {
            default: 400
        },
        visibility: {
            default: true
        }
    },
    [(0, $7dRgX.DEVOPS_INVITE_TEAMMATES_TASK)]: {
        position: {
            default: 500
        },
        visibility: {
            default: true
        }
    },
    [(0, $7dRgX.DEVOPS_FIND_HELP_TASK)]: {
        position: {
            default: 600
        },
        visibility: {
            default: true
        }
    }
};

});
parcelRegister("ePWG3", function(module, exports) {

$parcel$export(module.exports, "messages", () => $8c9ac3fc1eb167f1$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $8c9ac3fc1eb167f1$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    rootTitle: {
        "id": "software-onboarding-quickstart.services.tasks.config.devops.root-title.no-translate",
        "defaultMessage": "Quickstart"
    }
});

});



parcelRegister("3sCLn", function(module, exports) {

$parcel$export(module.exports, "JSM", () => $9ce9aa4e7fe0438e$export$63f289f2da861d35);

var $4Euci = parcelRequire("4Euci");
const $9ce9aa4e7fe0438e$export$63f289f2da861d35 = {
    taskList: (0, $4Euci.JSM_TASK_LIST),
    taskVariants: (0, $4Euci.JSM_TASK_VARIANTS),
    userRole: (0, $4Euci.UserRole),
    experiments: (0, $4Euci.Experiments)
};

});
parcelRegister("4Euci", function(module, exports) {

$parcel$export(module.exports, "JSM_TASK_LIST", () => $fb74ace10b289ae1$export$6c6c561944d49bcb);
$parcel$export(module.exports, "Experiments", () => $fb74ace10b289ae1$export$c8d6ffd15214553a);
$parcel$export(module.exports, "UserRole", () => $fb74ace10b289ae1$export$eb3485a690c2f0b8);
$parcel$export(module.exports, "JSM_TASK_VARIANTS", () => $fb74ace10b289ae1$export$5b68aef408c932d9);

var $7dRgX = parcelRequire("7dRgX");

var $aC2eo = parcelRequire("aC2eo");
const $fb74ace10b289ae1$export$6c6c561944d49bcb = Object.freeze({
    root: {
        title: (0, $aC2eo.messages).rootTitle,
        items: [
            (0, $7dRgX.JSM_REVIEW_YOUR_CHANNELS_TASK),
            (0, $7dRgX.JSM_CUSTOMIZE_YOUR_REQUEST_TYPES_TASK),
            (0, $7dRgX.JSM_INVITE_YOUR_TEAM_TASK)
        ]
    }
});
const $fb74ace10b289ae1$export$c8d6ffd15214553a = {
    projectTheming: 'projectTheming'
};
const $fb74ace10b289ae1$export$eb3485a690c2f0b8 = {
    projectAdmin: 'projectAdmin',
    jiraAdmin: 'jiraAdmin',
    siteAdmin: 'siteAdmin'
};
const $fb74ace10b289ae1$export$5b68aef408c932d9 = {
    [(0, $7dRgX.JSM_REVIEW_YOUR_CHANNELS_TASK)]: {
        position: {
            default: 0
        },
        visibility: {
            default: true
        }
    },
    [(0, $7dRgX.JSM_CUSTOMIZE_YOUR_REQUEST_TYPES_TASK)]: {
        position: {
            default: 1
        },
        visibility: {
            default: true
        }
    },
    [(0, $7dRgX.JSM_INVITE_YOUR_TEAM_TASK)]: {
        position: {
            default: 2
        },
        visibility: {
            default: true
        }
    }
};

});
parcelRegister("aC2eo", function(module, exports) {

$parcel$export(module.exports, "messages", () => $c73088a9cd2645bf$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $c73088a9cd2645bf$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    rootTitle: {
        "id": "software-onboarding-quickstart.services.tasks.config.jsm.root-title.no-translate",
        "defaultMessage": "Quickstart"
    }
});

});



parcelRegister("2UWYK", function(module, exports) {

$parcel$export(module.exports, "JSW", () => $bddfc54f60451b1f$export$4cfe6e52f2e72a54);

var $8nR1z = parcelRequire("8nR1z");
const $bddfc54f60451b1f$export$4cfe6e52f2e72a54 = {
    taskList: (0, $8nR1z.TASK_LIST),
    taskVariants: (0, $8nR1z.TASK_VARIANTS),
    experiment: (0, $8nR1z.Experiment),
    experience: (0, $8nR1z.Experience),
    projectStyle: (0, $8nR1z.ProjectStyle),
    projectProperties: (0, $8nR1z.ProjectProperties),
    userRole: (0, $8nR1z.UserRole),
    edition: (0, $8nR1z.Edition),
    route: (0, $8nR1z.Route),
    permissions: (0, $8nR1z.Permissions),
    trait: (0, $8nR1z.Trait)
};

});
parcelRegister("8nR1z", function(module, exports) {

$parcel$export(module.exports, "Experiment", () => $7a9145b1fc208f16$export$4e0ab25c8a7e4009);
$parcel$export(module.exports, "Experience", () => $7a9145b1fc208f16$export$c90b54e658fc4d7c);
$parcel$export(module.exports, "ProjectStyle", () => $7a9145b1fc208f16$export$1f66f9f05afa05a8);
$parcel$export(module.exports, "ProjectProperties", () => $7a9145b1fc208f16$export$543c19ee8dba9252);
$parcel$export(module.exports, "UserRole", () => $7a9145b1fc208f16$export$eb3485a690c2f0b8);
$parcel$export(module.exports, "Edition", () => $7a9145b1fc208f16$export$6f4a0f769e61929);
$parcel$export(module.exports, "Route", () => $7a9145b1fc208f16$export$e7b0ac011bb776c6);
$parcel$export(module.exports, "Permissions", () => $7a9145b1fc208f16$export$2d41982586bbb6be);
$parcel$export(module.exports, "Trait", () => $7a9145b1fc208f16$export$2d08cfa40d69142e);
$parcel$export(module.exports, "TASK_LIST", () => $7a9145b1fc208f16$export$601c8c0f45aeb0a0);
$parcel$export(module.exports, "TASK_VARIANTS", () => $7a9145b1fc208f16$export$36f4d47dfe11b613);

var $7dRgX = parcelRequire("7dRgX");

var $inMFY = parcelRequire("inMFY");
const $7a9145b1fc208f16$export$4e0ab25c8a7e4009 = {
    scrumOnboarding: 'experiment.scrumOnboarding',
    customizeSiteName: 'experiment.customizeSiteName',
    jswReverseTrial: 'experiment.jswReverseTrial',
    simplifyKanbanQS: 'experiment.simplifyKanbanQS',
    simplifyTmpQS: 'experiment.simplifyJswQSM3'
};
const $7a9145b1fc208f16$export$c90b54e658fc4d7c = {
    kanbanOnboarding: 'experience.kanbanOnboarding',
    fedRamp: 'experience.fedRamp'
};
const $7a9145b1fc208f16$export$1f66f9f05afa05a8 = {
    teamManaged: 'projectStyle.teamManaged',
    companyManaged: 'projectStyle.companyManaged'
};
const $7a9145b1fc208f16$export$543c19ee8dba9252 = {
    isCreatedFromCustomerTemplate: 'projectProperties.isCreatedFromCustomerTemplate'
};
const $7a9145b1fc208f16$export$eb3485a690c2f0b8 = {
    siteAdmin: 'userRole.siteAdmin',
    jiraAdmin: 'userRole.jiraAdmin',
    admin: 'userRole.admin',
    projectAdmin: 'userRole.projectAdmin'
};
const $7a9145b1fc208f16$export$6f4a0f769e61929 = {
    free: 'productEdition.free',
    standard: 'productEdition.standard',
    premium: 'productEdition.premium'
};
const $7a9145b1fc208f16$export$e7b0ac011bb776c6 = {
    softwareRoadmap: 'route.softwareRoadmap',
    softwareBacklog: 'route.softwareBacklog',
    softwareBoard: 'route.softwareBoard',
    softwareList: 'route.softwareList',
    projectSettingsSoftwareAccess: 'route.projectSettingsSoftwareAccess',
    issue: 'route.issue',
    softwareCalendar: 'route.softwareCalendar'
};
const $7a9145b1fc208f16$export$2d41982586bbb6be = {
    notCanCreateProject: 'permissions.notCanCreateProject',
    hasPlanEditPermissions: 'permissions.hasPlanEditPermissions'
};
const $7a9145b1fc208f16$export$2d08cfa40d69142e = {
    crossProjectBoardToPlanUpsell: 'trait.crossProjectBoardToPlanUpsell'
};
const $7a9145b1fc208f16$var$DEFAULT_TASK_LIST = [
    (0, $7dRgX.ADD_COLUMNS_TASK),
    (0, $7dRgX.CREATE_PROJECT_TASK),
    (0, $7dRgX.CREATE_ISSUE_TASK),
    (0, $7dRgX.CREATE_ISSUE_TASK_SIMPLIFIED),
    (0, $7dRgX.TRY_ATLASSIAN_UNIVERSITY_ONBOARDING_TASK),
    (0, $7dRgX.INVITE_TEAMMATES_TASK),
    (0, $7dRgX.INVITE_TEAMMATES_VIDEO_TASK),
    (0, $7dRgX.CAPTURE_INTEGRATIONS_TASK),
    (0, $7dRgX.FIND_HELP_TASK),
    (0, $7dRgX.SET_UP_BOARD_TASK),
    (0, $7dRgX.GET_MOBILE_APP_TASK),
    (0, $7dRgX.PREMIUM_REVERSE_TRIAL_TASK),
    (0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK),
    (0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN),
    (0, $7dRgX.STANDARD_EDITION_OVERVIEW_TASK),
    (0, $7dRgX.MAP_OUT_YOUR_PROJECT_GOALS_TASK),
    (0, $7dRgX.IDENTIFY_SMALL_CHUNKS_OF_WORK_TASK),
    (0, $7dRgX.IDENTIFY_SMALL_CHUNKS_OF_WORK_KANBAN_TASK),
    (0, $7dRgX.MONITOR_MANAGE_RISK_TASK),
    (0, $7dRgX.SCRUM_ONBOARDING_TASK),
    (0, $7dRgX.KANBAN_ONBOARDING_TASK),
    (0, $7dRgX.CUSTOMIZE_SITE_NAME_TASK),
    (0, $7dRgX.GET_TO_KNOW_YOUR_TEMPLATE_TASK),
    (0, $7dRgX.CREATE_BUSINESS_PROJECT_FROM_JSW_QUICKSTART_TASK),
    (0, $7dRgX.GET_STARTED_LIST_TASK),
    (0, $7dRgX.CALENDAR_VIEW_TASK)
];
const $7a9145b1fc208f16$export$601c8c0f45aeb0a0 = Object.freeze({
    root: {
        title: (0, $inMFY.messages).rootTitle,
        items: $7a9145b1fc208f16$var$DEFAULT_TASK_LIST
    },
    reverseTrialRoot: {
        title: (0, $inMFY.messages).reverseTrialRootTitle,
        items: $7a9145b1fc208f16$var$DEFAULT_TASK_LIST
    },
    [(0, $7dRgX.PREMIUM_REVERSE_TRIAL_TASK)]: {
        title: (0, $inMFY.messages).reverseTrialCardTitle,
        items: [
            (0, $7dRgX.ADVANCED_ROADMAPS_TASK),
            (0, $7dRgX.CHANGE_CONTROL_TASK),
            (0, $7dRgX.AUTOMATIONS_TASK),
            (0, $7dRgX.SITE_ADMINISTRATIONS_TASK),
            (0, $7dRgX.USER_MANAGEMENT_TASK)
        ]
    },
    [(0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK)]: {
        title: (0, $inMFY.messages).premiumPlanTitle,
        items: [
            (0, $7dRgX.ADVANCED_ROADMAPS_TASK),
            (0, $7dRgX.CHANGE_CONTROL_TASK),
            (0, $7dRgX.AUTOMATIONS_TASK),
            (0, $7dRgX.SITE_ADMINISTRATIONS_TASK),
            (0, $7dRgX.USER_MANAGEMENT_TASK)
        ]
    },
    [(0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN)]: {
        title: (0, $inMFY.messages).premiumPlanTitle,
        items: [
            (0, $7dRgX.ADVANCED_ROADMAPS_TASK),
            (0, $7dRgX.AUTOMATIONS_TASK)
        ]
    },
    [(0, $7dRgX.STANDARD_EDITION_OVERVIEW_TASK)]: {
        title: (0, $inMFY.messages).standardPlanTitle,
        items: [
            (0, $7dRgX.AUTOMATIONS_TASK),
            (0, $7dRgX.USER_MANAGEMENT_TASK),
            (0, $7dRgX.SITE_ADMINISTRATIONS_TASK)
        ]
    }
});
const $7a9145b1fc208f16$var$PLAN_ONBOARDING_TASKS = {
    [(0, $7dRgX.PREMIUM_REVERSE_TRIAL_TASK)]: {
        position: {
            default: 900
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.jswReverseTrial,
                        $7a9145b1fc208f16$export$6f4a0f769e61929.premium
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK)]: {
        position: {
            default: 100,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyKanbanQS
                    ],
                    value: 900
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyTmpQS,
                        $7a9145b1fc208f16$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: 900
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.jswReverseTrial,
                        $7a9145b1fc208f16$export$6f4a0f769e61929.premium,
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.admin
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$6f4a0f769e61929.premium,
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN)]: {
        position: {
            default: 100,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyKanbanQS
                    ],
                    value: 900
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyTmpQS,
                        $7a9145b1fc208f16$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: 900
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    // This condition needs to be the opposite condition to PREMIUM_EDITION_OVERVIEW_TASK
                    condition: [
                        $7a9145b1fc208f16$export$6f4a0f769e61929.premium,
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.admin
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.jswReverseTrial,
                        $7a9145b1fc208f16$export$6f4a0f769e61929.premium
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$6f4a0f769e61929.premium
                    ],
                    value: true
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$2d08cfa40d69142e.crossProjectBoardToPlanUpsell,
                        $7a9145b1fc208f16$export$2d41982586bbb6be.hasPlanEditPermissions
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.STANDARD_EDITION_OVERVIEW_TASK)]: {
        position: {
            default: 100,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyKanbanQS
                    ],
                    value: 900
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyTmpQS,
                        $7a9145b1fc208f16$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: 900
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$6f4a0f769e61929.standard,
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.ADVANCED_ROADMAPS_TASK)]: {
        position: {
            default: 105
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$2d08cfa40d69142e.crossProjectBoardToPlanUpsell,
                        $7a9145b1fc208f16$export$2d41982586bbb6be.hasPlanEditPermissions
                    ],
                    value: true
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$6f4a0f769e61929.premium
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.AUTOMATIONS_TASK)]: {
        position: {
            default: 110
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$2d08cfa40d69142e.crossProjectBoardToPlanUpsell,
                        $7a9145b1fc208f16$export$2d41982586bbb6be.hasPlanEditPermissions
                    ],
                    value: true
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$6f4a0f769e61929.premium,
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$6f4a0f769e61929.standard,
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.USER_MANAGEMENT_TASK)]: {
        position: {
            default: 115
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$6f4a0f769e61929.premium,
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$6f4a0f769e61929.standard,
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.CHANGE_CONTROL_TASK)]: {
        position: {
            default: 120
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$6f4a0f769e61929.premium,
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.siteAdmin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.SITE_ADMINISTRATIONS_TASK)]: {
        position: {
            default: 125
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$6f4a0f769e61929.premium,
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.siteAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$6f4a0f769e61929.standard,
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.siteAdmin
                    ],
                    value: true
                }
            ]
        }
    }
};
const $7a9145b1fc208f16$var$CUSTOMER_TEMPLATE_ONBOARDING_TASKS = {
    [(0, $7dRgX.GET_TO_KNOW_YOUR_TEMPLATE_TASK)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$543c19ee8dba9252.isCreatedFromCustomerTemplate,
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.siteAdmin
                    ],
                    value: true
                }
            ]
        }
    }
};
const $7a9145b1fc208f16$export$36f4d47dfe11b613 = {
    ...$7a9145b1fc208f16$var$PLAN_ONBOARDING_TASKS,
    ...$7a9145b1fc208f16$var$CUSTOMER_TEMPLATE_ONBOARDING_TASKS,
    [(0, $7dRgX.CREATE_PROJECT_TASK)]: {
        position: {
            default: 0
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$2d41982586bbb6be.notCanCreateProject
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$543c19ee8dba9252.isCreatedFromCustomerTemplate
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $7dRgX.CUSTOMIZE_SITE_NAME_TASK)]: {
        position: {
            default: 50
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.siteAdmin,
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.customizeSiteName
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.CALENDAR_VIEW_TASK)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    value: true,
                    condition: [
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareCalendar
                    ]
                }
            ]
        }
    },
    [(0, $7dRgX.SCRUM_ONBOARDING_TASK)]: {
        position: {
            default: 150
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.siteAdmin,
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyTmpQS,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareBacklog,
                        $7a9145b1fc208f16$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.siteAdmin,
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.scrumOnboarding,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareBacklog
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.KANBAN_ONBOARDING_TASK)]: {
        position: {
            default: 150
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyKanbanQS
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.MAP_OUT_YOUR_PROJECT_GOALS_TASK)]: {
        position: {
            default: 150
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyTmpQS,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareRoadmap,
                        $7a9145b1fc208f16$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareRoadmap
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.IDENTIFY_SMALL_CHUNKS_OF_WORK_TASK)]: {
        position: {
            default: 151
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyTmpQS,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareRoadmap,
                        $7a9145b1fc208f16$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareRoadmap
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.IDENTIFY_SMALL_CHUNKS_OF_WORK_KANBAN_TASK)]: {
        position: {
            default: 151
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyKanbanQS,
                        $7a9145b1fc208f16$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.MONITOR_MANAGE_RISK_TASK)]: {
        position: {
            default: 152
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyTmpQS,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareRoadmap,
                        $7a9145b1fc208f16$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareRoadmap
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.SET_UP_BOARD_TASK)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyKanbanQS,
                        $7a9145b1fc208f16$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyTmpQS,
                        $7a9145b1fc208f16$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$c90b54e658fc4d7c.kanbanOnboarding
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareList
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.projectAdmin,
                        $7a9145b1fc208f16$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.CREATE_ISSUE_TASK)]: {
        position: {
            default: 300
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyTmpQS,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.issue
                    ],
                    value: true
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyTmpQS,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.projectSettingsSoftwareAccess
                    ],
                    value: true
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyTmpQS,
                        $7a9145b1fc208f16$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $7dRgX.CREATE_ISSUE_TASK_SIMPLIFIED)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyTmpQS,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.issue
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyTmpQS,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.projectSettingsSoftwareAccess
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyTmpQS,
                        $7a9145b1fc208f16$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: true
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyKanbanQS,
                        $7a9145b1fc208f16$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.ADD_COLUMNS_TASK)]: {
        position: {
            default: 310
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyTmpQS,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.issue
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyTmpQS,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.projectSettingsSoftwareAccess
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyKanbanQS,
                        $7a9145b1fc208f16$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: true
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyTmpQS,
                        $7a9145b1fc208f16$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.GET_STARTED_LIST_TASK)]: {
        position: {
            default: 320
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyTmpQS,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareList
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareList
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.TRY_ATLASSIAN_UNIVERSITY_ONBOARDING_TASK)]: {
        position: {
            default: 350
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyTmpQS,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.issue
                    ],
                    value: true
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyTmpQS,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.projectSettingsSoftwareAccess
                    ],
                    value: true
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyKanbanQS,
                        $7a9145b1fc208f16$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyTmpQS,
                        $7a9145b1fc208f16$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $7dRgX.INVITE_TEAMMATES_TASK)]: {
        position: {
            default: 400
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.projectAdmin,
                        $7a9145b1fc208f16$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.admin,
                        $7a9145b1fc208f16$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $7dRgX.INVITE_TEAMMATES_VIDEO_TASK)]: {
        position: {
            default: 400,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyTmpQS,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.issue
                    ],
                    value: 400
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyTmpQS,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.projectSettingsSoftwareAccess
                    ],
                    value: 400
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyKanbanQS,
                        $7a9145b1fc208f16$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: 600
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyTmpQS,
                        $7a9145b1fc208f16$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: 600
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.projectAdmin,
                        $7a9145b1fc208f16$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: true
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.admin,
                        $7a9145b1fc208f16$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.CAPTURE_INTEGRATIONS_TASK)]: {
        position: {
            default: 500
        },
        visibility: {
            default: true
        }
    },
    [(0, $7dRgX.GET_MOBILE_APP_TASK)]: {
        position: {
            default: 600
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$c90b54e658fc4d7c.fedRamp
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyTmpQS,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.issue
                    ],
                    value: true
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyTmpQS,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.projectSettingsSoftwareAccess
                    ],
                    value: true
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyKanbanQS,
                        $7a9145b1fc208f16$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyTmpQS,
                        $7a9145b1fc208f16$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $7dRgX.FIND_HELP_TASK)]: {
        position: {
            default: 700
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyTmpQS,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.issue
                    ],
                    value: true
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyTmpQS,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.projectSettingsSoftwareAccess
                    ],
                    value: true
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyKanbanQS,
                        $7a9145b1fc208f16$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyTmpQS,
                        $7a9145b1fc208f16$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $7dRgX.CREATE_BUSINESS_PROJECT_FROM_JSW_QUICKSTART_TASK)]: {
        position: {
            default: 800
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$2d41982586bbb6be.notCanCreateProject
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyTmpQS,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.issue
                    ],
                    value: true
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyTmpQS,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.projectSettingsSoftwareAccess
                    ],
                    value: true
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyKanbanQS,
                        $7a9145b1fc208f16$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyTmpQS,
                        $7a9145b1fc208f16$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: false
                }
            ]
        }
    }
};

});
parcelRegister("inMFY", function(module, exports) {

$parcel$export(module.exports, "messages", () => $52d99860e7a60493$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $52d99860e7a60493$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    rootTitle: {
        "id": "software-onboarding-quickstart.services.tasks.config.jsw.root-title.no-translate",
        "defaultMessage": "Quickstart"
    },
    premiumPlanTitle: {
        "id": "onboarding-quickstart-core.services.tasks.config.jsw.premium-plan-title",
        "defaultMessage": "Included in your Premium plan"
    },
    standardPlanTitle: {
        "id": "onboarding-quickstart-core.services.tasks.config.jsw.standard-plan-title",
        "defaultMessage": "Your Standard plan"
    },
    reverseTrialRootTitle: {
        "id": "onboarding-quickstart-core.services.tasks.config.jsw.reverse-trial-root-title",
        "defaultMessage": "Your 30-day Premium trial"
    },
    reverseTrialCardTitle: {
        "id": "onboarding-quickstart-core.services.tasks.config.jsw.reverse-trial-card-title",
        "defaultMessage": "Included in your Premium trial"
    }
});

});



parcelRegister("c2fmF", function(module, exports) {

$parcel$export(module.exports, "JWM", () => $562f552a719c049d$export$3ff26c80cb588e12);

var $l40o4 = parcelRequire("l40o4");

var $hBhFD = parcelRequire("hBhFD");

var $kN5DK = parcelRequire("kN5DK");
const $562f552a719c049d$export$3ff26c80cb588e12 = {
    taskList: (0, $l40o4.TASK_LIST),
    taskVariants: (0, $l40o4.TASK_VARIANTS),
    userRole: (0, $kN5DK.UserRole),
    experiments: (0, $hBhFD.Experiments),
    personalizedExperienceExperiments: (0, $hBhFD.PersonalizedExperienceExperiments)
};

});
parcelRegister("l40o4", function(module, exports) {

$parcel$export(module.exports, "TASK_LIST", () => $0a485b7af0b81750$export$601c8c0f45aeb0a0);
$parcel$export(module.exports, "TASK_VARIANTS", () => $0a485b7af0b81750$export$36f4d47dfe11b613);

var $7dRgX = parcelRequire("7dRgX");

var $hBhFD = parcelRequire("hBhFD");

var $1deRh = parcelRequire("1deRh");

var $kN5DK = parcelRequire("kN5DK");
const $0a485b7af0b81750$export$601c8c0f45aeb0a0 = Object.freeze({
    root: {
        title: (0, $1deRh.messages).rootTitle,
        items: [
            (0, $7dRgX.JWM_CREATE_PROJECT_TASK),
            (0, $7dRgX.JWM_TRELLO_CROSSFLOW_TASK_IMPORT),
            (0, $7dRgX.JWM_SUMMARY_AND_REPORTS_TASK),
            (0, $7dRgX.JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK),
            (0, $7dRgX.JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES),
            (0, $7dRgX.JWM_CREATE_SAMPLE_PROJECT_TASK),
            (0, $7dRgX.JWM_PROJECT_SUMMARY_TASK),
            (0, $7dRgX.JWM_GET_STARTED_LIST_TASK),
            (0, $7dRgX.JWM_CALENDAR_TASK),
            (0, $7dRgX.JWM_BOARD_TASK),
            (0, $7dRgX.JWM_TIMELINE_TASK),
            (0, $7dRgX.JWM_BUILD_FORM_TASK),
            (0, $7dRgX.JWM_BACKGROUND_COLOR_TASK),
            (0, $7dRgX.JWM_FEEDBACK_TASK),
            (0, $7dRgX.JWM_FEEDBACK_SAMPLE_PROJECT_TASK),
            (0, $7dRgX.JWM_SHARE_PROJECT_TASK),
            (0, $7dRgX.JWM_CREATE_YOUR_OWN_PROJECT_TASK),
            (0, $7dRgX.JWM_SUMMARY_TASK),
            (0, $7dRgX.JWM_INVITE_TEAM_TASK),
            (0, $7dRgX.JWM_PAGES_TASK)
        ]
    }
});
const $0a485b7af0b81750$export$36f4d47dfe11b613 = {
    [(0, $7dRgX.JWM_CREATE_PROJECT_TASK)]: {
        position: {
            default: 0
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isSampleProject
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES)]: {
        position: {
            default: 15
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isNotSampleProject,
                        (0, $hBhFD.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_CREATE_SAMPLE_PROJECT_TASK)]: {
        position: {
            default: 40
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isSampleProject
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_PROJECT_SUMMARY_TASK)]: {
        position: {
            default: 50
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isSampleProject
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_GET_STARTED_LIST_TASK)]: {
        position: {
            default: 100
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isSampleProject
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).trelloCrossflow
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_CALENDAR_TASK)]: {
        position: {
            default: 200,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).personalizedExperience,
                        (0, $hBhFD.PersonalizedExperienceExperiments).contentMarketer
                    ],
                    value: 60
                }
            ]
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isSampleProject
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).trelloCrossflow
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).personalizedExperience,
                        (0, $hBhFD.PersonalizedExperienceExperiments).projectMarketer
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).personalizedExperience
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_BOARD_TASK)]: {
        position: {
            default: 250
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).personalizedExperience
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_TIMELINE_TASK)]: {
        position: {
            default: 300
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isSampleProject
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).trelloCrossflow
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).personalizedExperience,
                        (0, $hBhFD.PersonalizedExperienceExperiments).contentMarketer
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_PAGES_TASK)]: {
        position: {
            default: 375,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).personalizedExperience,
                        (0, $hBhFD.PersonalizedExperienceExperiments).projectMarketer
                    ],
                    value: 325
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).personalizedExperience,
                        (0, $hBhFD.PersonalizedExperienceExperiments).marketingLeader
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).personalizedExperience
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_SUMMARY_TASK)]: {
        position: {
            default: 350
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).personalizedExperience
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_BUILD_FORM_TASK)]: {
        position: {
            default: 400
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).personalizedExperience,
                        (0, $hBhFD.PersonalizedExperienceExperiments).contentMarketer
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).personalizedExperience
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK)]: {
        position: {
            default: 425
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isNotSampleProject,
                        (0, $hBhFD.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_SUMMARY_AND_REPORTS_TASK)]: {
        position: {
            default: 450
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isNotSampleProject,
                        (0, $hBhFD.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_BACKGROUND_COLOR_TASK)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).projectTheming,
                        (0, $kN5DK.UserRole).jiraAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).projectTheming,
                        (0, $kN5DK.UserRole).siteAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).projectTheming,
                        (0, $kN5DK.UserRole).projectAdmin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_INVITE_TEAM_TASK)]: {
        position: {
            default: 550
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).personalizedExperience
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_SHARE_PROJECT_TASK)]: {
        position: {
            default: 600
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isSampleProject
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_TRELLO_CROSSFLOW_TASK_IMPORT)]: {
        position: {
            default: 650
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isNotSampleProject,
                        (0, $hBhFD.Experiments).trelloCrossflow,
                        (0, $kN5DK.UserRole).siteAdmin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_FEEDBACK_TASK)]: {
        position: {
            default: 700
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isSampleProject
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).trelloCrossflow
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).personalizedExperience
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_FEEDBACK_SAMPLE_PROJECT_TASK)]: {
        position: {
            default: 700
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isSampleProject
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_CREATE_YOUR_OWN_PROJECT_TASK)]: {
        position: {
            default: 800
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isSampleProject,
                        (0, $kN5DK.UserRole).jiraAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).isSampleProject,
                        (0, $kN5DK.UserRole).siteAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).isSampleProject,
                        (0, $kN5DK.UserRole).projectAdmin
                    ],
                    value: true
                }
            ]
        }
    }
};

});
parcelRegister("hBhFD", function(module, exports) {

$parcel$export(module.exports, "Experiments", () => $602d627ebd2e1820$export$c8d6ffd15214553a);
$parcel$export(module.exports, "PersonalizedExperienceExperiments", () => $602d627ebd2e1820$export$ce14e6ba2f059143);
const $602d627ebd2e1820$export$c8d6ffd15214553a = {
    projectTheming: 'projectTheming',
    isSampleProject: 'isSampleProject',
    isNotSampleProject: 'isNotSampleProject',
    trelloCrossflow: 'trelloCrossflow',
    personalizedExperience: 'personalizedExperience'
};
const $602d627ebd2e1820$export$ce14e6ba2f059143 = {
    marketingLeader: 'personalizedExperience.marketing-leader',
    contentMarketer: 'personalizedExperience.content-marketer',
    projectMarketer: 'personalizedExperience.project-marketer',
    productMarketingManager: 'personalizedExperience.pmm'
};

});

parcelRegister("1deRh", function(module, exports) {

$parcel$export(module.exports, "messages", () => $9c87cc11a21af694$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $9c87cc11a21af694$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    rootTitle: {
        "id": "software-onboarding-quickstart.services.tasks.config.jwm.root-title.no-translate",
        "defaultMessage": "Quickstart"
    }
});

});

parcelRegister("kN5DK", function(module, exports) {

$parcel$export(module.exports, "UserRole", () => $c7f18eb8f889bc31$export$eb3485a690c2f0b8);
const $c7f18eb8f889bc31$export$eb3485a690c2f0b8 = {
    projectAdmin: 'projectAdmin',
    jiraAdmin: 'jiraAdmin',
    siteAdmin: 'siteAdmin'
};

});



parcelRegister("2hhuw", function(module, exports) {

$parcel$export(module.exports, "getTasks", () => $1a771609d4c77a5c$export$20b82b4a32771893);

var $kfb7k = parcelRequire("kfb7k");
const $1a771609d4c77a5c$var$getTaskVisibility = (variants, visibility)=>visibility !== undefined ? (0, $kfb7k.getConditional)(visibility, variants) : true;
const $1a771609d4c77a5c$var$getTaskPosition = (variants, position)=>(0, $kfb7k.getConditional)(position, variants);
const $1a771609d4c77a5c$export$20b82b4a32771893 = (variants, taskVariants, taskList)=>taskList.filter((task)=>$1a771609d4c77a5c$var$getTaskVisibility(variants, taskVariants[task].visibility)).sort((taskA, taskB)=>$1a771609d4c77a5c$var$getTaskPosition(variants, taskVariants[taskA].position) - $1a771609d4c77a5c$var$getTaskPosition(variants, taskVariants[taskB].position));

});
parcelRegister("kfb7k", function(module, exports) {

$parcel$export(module.exports, "getConditional", () => $75b9324579affeba$export$fe3161cde0106bba);
const $75b9324579affeba$export$fe3161cde0106bba = ({ conditional: conditions, default: defaultValue }, variants)=>{
    if (conditions === undefined) return defaultValue;
    const variantsIncludesCondition = (c)=>variants.includes(c);
    const conditionObj = conditions.find(({ condition: condition })=>condition.every(variantsIncludesCondition));
    return conditionObj ? conditionObj.value : defaultValue;
};

});


parcelRegister("5f5jN", function(module, exports) {

$parcel$export(module.exports, "isJwmProject", () => $4c12cc14f77b8d26$export$ea2e5a5c1a1a6748);
$parcel$export(module.exports, "isJsmProject", () => $4c12cc14f77b8d26$export$a972ed853ed1d469);

var $7ZZxN = parcelRequire("7ZZxN");
const $4c12cc14f77b8d26$export$ea2e5a5c1a1a6748 = (projectState)=>projectState?.projectType === (0, $7ZZxN.CORE_PROJECT);
const $4c12cc14f77b8d26$export$a972ed853ed1d469 = (projectState)=>projectState?.projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT);

});




parcelRegister("lCsoa", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $eba3eaa3fc426760$export$d4c72bab9d6cc13a);

var $7dRgX = parcelRequire("7dRgX");
const $eba3eaa3fc426760$export$d4c72bab9d6cc13a = {
    shouldRenderComponent: false,
    completedTaskList: [],
    hasSeenTasks: [],
    isDismissed: true,
    isOpen: false,
    isFocusedOn: false,
    openTask: '',
    projectState: null,
    hasNudgeActive: false,
    isQuickstartLoaded: false,
    isDevOpsProject: false,
    nudgeStep: '',
    mountedNudges: [],
    hasEverSeenRoute: {
        'jsw.onboarding.experiment.personalised.onboarding.ntkw.onboarding.it2.roadmap': false
    },
    roadmapIsCreateEnabled: false,
    roadmapIsListEmpty: true,
    previousTaskGroupParents: [],
    currentTaskGroupParent: (0, $7dRgX.ROOT_TASK),
    selectedProjectTemplateKeyFromOnboarding: undefined,
    isEligibleToUpdateSitename: false,
    isCrossProjectBoardToPlanUpsell: false,
    canEditPlans: false,
    visibility: {
        [(0, $7dRgX.QUICKSTART_TYPE).JSM_BUSINESS_QUICKSTART_KEY]: (0, $7dRgX.QUICKSTART_UI_STATUS).NOT_LOADED,
        [(0, $7dRgX.QUICKSTART_TYPE).OLD_GLOBAL_QUICKSTART_KEY]: (0, $7dRgX.QUICKSTART_UI_STATUS).NOT_LOADED
    }
};

});

parcelRegister("7AH2S", function(module, exports) {

$parcel$export(module.exports, "useOrgId", () => $eea7a281b809b1c9$export$52a03a3207af3687);

var $eUqFw = parcelRequire("eUqFw");

var $dWLk9 = parcelRequire("dWLk9");
var $1R3n5 = parcelRequire("1R3n5");

var $9qoWk = parcelRequire("9qoWk");
const $eea7a281b809b1c9$export$52a03a3207af3687 = ()=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const isSiteAdmin = (0, $1R3n5.useIsSiteAdmin)();
    const [{ value: value }, { fetchOrgId: fetchOrgId }] = (0, $9qoWk.useLinkedOrg)();
    (0, $eUqFw.useEffect)(()=>{
        if (isSiteAdmin) fetchOrgId(cloudId);
    }, [
        fetchOrgId,
        isSiteAdmin,
        cloudId
    ]);
    return value;
};

});
parcelRegister("9qoWk", function(module, exports) {

$parcel$export(module.exports, "useLinkedOrg", () => $136457ccda5882c7$export$cefa7c513db62fe3);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $k0YUt = parcelRequire("k0YUt");
const $136457ccda5882c7$var$actions = {
    fetchOrgId: $k0YUt.fetchOrgId
};
const $136457ccda5882c7$var$initialState = {
    isFetching: false,
    wasFetched: false,
    fetchedOnce: false
};
const $136457ccda5882c7$var$Store = (0, $a61MH.createStore)({
    initialState: $136457ccda5882c7$var$initialState,
    actions: $136457ccda5882c7$var$actions,
    name: 'jsw-onboarding-quickstart-linked-org'
});
const $136457ccda5882c7$export$cefa7c513db62fe3 = (0, $ggKAj.createHook)($136457ccda5882c7$var$Store);

});
parcelRegister("k0YUt", function(module, exports) {

$parcel$export(module.exports, "fetchOrgId", () => $1a44f805e278eb93$export$c78d9b18cf152ce8);

var $lIoQU = parcelRequire("lIoQU");

var $5IvqT = parcelRequire("5IvqT");

var $38Uht = parcelRequire("38Uht");
const $1a44f805e278eb93$export$5a762450d50ca901 = async (cloudId)=>{
    try {
        const result = await (0, $38Uht.getLinkedOrg)(cloudId);
        return result.id;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $lIoQU.fireAPIErrorAnalytics)(error, 'getLinkedOrg');
    }
    return null;
};
const $1a44f805e278eb93$export$c78d9b18cf152ce8 = (0, $5IvqT.cachedEndpointCall)($1a44f805e278eb93$export$5a762450d50ca901);

});
parcelRegister("5IvqT", function(module, exports) {

$parcel$export(module.exports, "cachedEndpointCall", () => $a81d42548e97f6e6$export$9ab04ab45a9b99da);
const $a81d42548e97f6e6$export$9ab04ab45a9b99da = (call)=>(props)=>async ({ getState: getState, setState: setState })=>{
            const { isFetching: isFetching, wasFetched: wasFetched, fetchedOnce: fetchedOnce } = getState();
            if (isFetching) return;
            if (wasFetched) return;
            setState({
                isFetching: true
            });
            const value = await call(props);
            if (value !== null) setState({
                value: value,
                isFetching: false,
                wasFetched: true,
                fetchedOnce: true
            });
            else setState({
                isFetching: false,
                wasFetched: fetchedOnce,
                fetchedOnce: true
            });
        };

});

parcelRegister("38Uht", function(module, exports) {

$parcel$export(module.exports, "getLinkedOrg", () => $3ce7ef8e40b0a0d5$export$fee654dbe03c901f);

var $2OdyW = parcelRequire("2OdyW");
const $3ce7ef8e40b0a0d5$export$fee654dbe03c901f = (cloudId)=>(0, $2OdyW.default)(`/gateway/api/adminhub/sites/${cloudId}/linked-org`, {
        method: 'GET'
    });

});





parcelRegister("iyAyt", function(module, exports) {

$parcel$export(module.exports, "InstrumentedNudgeSpotlightCard", () => $be8dce4766c764c0$export$b796db12a7c1d131);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

var $ewdMq = parcelRequire("ewdMq");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $be8dce4766c764c0$var$LazyInstrumentedNudgeSpotlightCard = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("ectvu")).then((exportedModule)=>exportedModule.InstrumentedNudgeSpotlightCard), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/onboarding/onboarding-quickstart-core/src/common/ui/instrumented-nudge-spotlight-card/main.tsx"
});
const $be8dce4766c764c0$export$b796db12a7c1d131 = ({ children: children = null, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ewdMq.OnboardingNudgeErrorBoundary), {
        id: "instrumentedNudgeSpotlightCard",
        fallback: children,
        attributes: {
            nudgeId: props.nudgeId
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "lazy-instrumented-nudge-spotlight-card",
        fallback: children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($be8dce4766c764c0$var$LazyInstrumentedNudgeSpotlightCard, props, children)));

});
parcelRegister("ectvu", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('kLFBl')
        ]);
        const value = parcelRequire('h95wo');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("kLFBl")
    ]).then(()=>parcelRequire('h95wo'));
}

});


parcelRegister("8AAak", function(module, exports) {

$parcel$export(module.exports, "BoldWrapper", () => $2c0d1a5b2373cc88$export$af2255ab82cde50a);

var $eUqFw = parcelRequire("eUqFw");
const $2c0d1a5b2373cc88$export$af2255ab82cde50a = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", null, children);

});

parcelRegister("b8MfW", function(module, exports) {

$parcel$export(module.exports, "default", () => $0babb750ef356368$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $0babb750ef356368$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    content: {
        "id": "software-onboarding-nudges--next.navigation-profile.content",
        "defaultMessage": "To reopen quickstart, select your profile icon, then {tagStart}Open Quickstart{tagEnd}. If you\u2019re looking for extra support, select {tagStart}Help{tagEnd} (?) to find articles that relate to your task."
    }
});

});



//# sourceMappingURL=async-software-onboarding-navigation-profile-nudge.c73c3c01.js.map
